import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";

import {
  Button,
  IconButton,
  TextField,
  Card,
  CardContent,
  LinearProgress,
} from "@mui/material";

import { useParams, Link, useLocation, useNavigationType } from "react-router-dom";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ConfirmExitModal from "./ConfirmExitModal";
import { ChevronLeft, ChevronRight, Tune } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Cookies from "js-cookie";
import AudioRecorder from "./AudioRecorder";
import LoadingComponent from "../loading";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddIcon from "@mui/icons-material/Add";
import { ayurvedaAssessments } from "../Appointments/ayurvedaAssessments";
import usePrescriptionStore from "../DataRepository/Prescription";
import axios from "axios";
import { reportsModel,kioskModel } from "../Axios/AxiosConfig";
import { InputAdornment, Drawer, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import AISuggestionsImg from "../Assets/images/Group 10923.png";

import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Chip,
  CircularProgress,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { toast, Zoom } from "react-toastify";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";

import { Checkbox, FormControlLabel, Grid, Autocomplete } from "@mui/material";
import AudioPlayer from "react-h5-audio-player";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "react-h5-audio-player/lib/styles.css";
import Slide from "@mui/material/Slide";
import { Slider } from "@mui/material";
import AgniIcon from '../Assets/images/Agni.png';
import KosthamIcon from '../Assets/images/Koshtam.png';
import MalamIcon from '../Assets/images/Manas-1.png';
import MansaIcon from '../Assets/images/Manas.png';
import MutramIcon from '../Assets/images/Mutram.png';
import NidraIcon from '../Assets/images/Nidra.png';
import VyadhiavasthaIcon from '../Assets/images/Vyadhiavastha.png';
import VyayamamIcon from '../Assets/images/Vyayamam.png';
import Patient_Profile from "../Appointments/Patient_Profile";
import { useNavigate, UNSAFE_NavigationContext as NavigationContext, } from "react-router-dom";
import Appointments from "../Appointments/Appointments";
import {
  profileModel,
  shopModel,
  prescriptionModel,
  teleConsultationModel,
} from "../Axios/AxiosConfig";
import DynamicContentRenderer from "./DynamicContentRender";
import Loader from "../loading";
import ReportStore from "../DataRepository/Reports";
import ShopStore from "../DataRepository/ShopStore";
import { usePrompt } from "./uesPrompt";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


function UploadPrescription(promptMessage = 'Changes you made may not be saved. Are you sure you want to leave ?') {


  let {
    selectedPatientdetails,
    selectedAppointemntdetails,
    yogalist,
    setyogalist,
    pranayama,
    FoodtobeTaken,
    labTests,
    setLabTests,
    currentDrugs,
    addCurrentdrugs,
    removeCurrentdrugs,
    updateCurrentdrugs,
    Foodtobeavoided,
    setFoodtobetaken,
    setFoodtobeAvoided,
    Medicineinputs,
    setMedicineinputs,
    lifestylechanges,
    setlifestylechanges,
    selectedRecipes,
    Ayurvedaparameters,
    handleAnswerSelect,
    handleSaveResult,
    setAyurvedaparameters,
    handleSelectRecipe,
    familyHistory,
    setFamilyHistory,
    symptoms,
    setSymptoms,
    setSelectedRecipes,
    FollowUp,
    setcurrentDrugs,
    setfollowup,
    meditationList,
    setMeditationlist,
    Prakriti_details,
    setDosham,
    setPrakritiDetails,
    diseases,
    metrics,
    setMetrics,
    customMetrics,
    setCustomMetrics,
    getLifestylePracticesRecommendations,
    getPulseDetails,
    setDiseases,
    setPranayamaList,
    Dosham,
    doshaAIdiagnois,
    setdoshaAIdiagnois,
    HandleDosham,
    Medicaldetails,
    setMedicaldetails,
    updateDoshaPercentage,
    updateDoshaIntensity,
    resetPrescriptionState,
    getMedicineRecommendations,
    formData,
    setFormData,
    audioBase64,
    selectedPrescription,
    isEditingResult,
    editValue,
    handleEditResult,
    handleCancelResult,
    setEditValue,
    setIsEditingResult,
    setSelectedPatientdetails,
    setPrescription,
    patientProfile,
    setPatientProfile,
    recipeLoading,
    setRecipeLoading,
    MedicineRecommendationLoading,
    lifestylePracticesLoading,
    herbalProducts,
    setHerbalProducts,
    AllDiet,
    setAllDiet,
    AllrawDiet,
    setAllrawDiet,
    AllRecipes,
    setAllRecipes,
    Practices,
    setPractices,
    transcript,
    setTranscript,
    error,
    setError,
    includedCategories,
    setincludedCategories,
    avoidedCategories,
    setavoidedCategories,
    recipeAIRecommendation,
    setRecipeAIRecommendation,
    Recipes,
    setRecipes,
    creationStartTime,
    setCreationStartTime,
    complications,
    setComplications,
    habits,
    setHabits,
  } = usePrescriptionStore();

  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");

  const [showExitModal, setShowExitModal] = useState(false);

  const [shouldNavigate, setShouldNavigate] = useState(false);

  const hasPushed = useRef(false);

  const popStateHandlerRef = useRef(null);

  const { state } = useLocation();

  const isFollowUpEdit = state?.isFollowUpEdit || false;

  useEffect(() => {

    const handleBeforeUnload = (event) => {
      if (!shouldNavigate) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    const handlePopState = () => {
      if (!shouldNavigate) {

        setShowExitModal(true);

        setacknowledge(true);

        window.history.pushState(null, '');

      }
    };

    popStateHandlerRef.current = handlePopState;

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);


    if (!hasPushed.current) {
      window.history.replaceState(null, '');
      window.history.pushState({ custom: true }, '');
      hasPushed.current = true;
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [shouldNavigate]);


  useEffect(() => {
    if (shouldNavigate) {
      setShowExitModal(false);
      if (popStateHandlerRef.current) {
        window.removeEventListener('popstate', popStateHandlerRef.current);
      }
    }
  }, [shouldNavigate]);

  const { getAIReports, AIReports, isReportsLoading, aiParameters, setAiParameters, Reports, clearReportsStore, getReports } = ReportStore();

  useEffect(() => {
    const patientUID = selectedPatientdetails?.UID;
    const appointmentId =
      selectedAppointemntdetails?.Appointment_id ||
      selectedAppointemntdetails?.id ||
      selectedAppointemntdetails?._id;

    if (!patientUID) return;

    getReports(patientUID);

    if (aiParameters.length === 0 && (!selectedPrescription?.AI_Reports || selectedPrescription.AI_Reports.length === 0) && appointmentId) {
      getAIReports(patientUID, appointmentId);
    }
  }, [
    selectedPatientdetails?.UID,
    selectedAppointemntdetails?.Appointment_id,
    selectedAppointemntdetails?.id,
    selectedAppointemntdetails?._id,
    selectedPrescription?.AI_Reports?.length,
    aiParameters.length
  ]);

  const [selectedProductCategory, setSelectedProductCategory] = useState("All");

  const [open, setOpen] = useState(false);
  const [productVariants, setProductVariants] = useState({}); // { productId: variantId }

  const [open2, setOpen2] = useState(false);

  const [open3, setOpen3] = useState(false);

  const [open4, setOpen4] = useState(false);

  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (!creationStartTime) {
      setCreationStartTime(Date.now());
    }
  }, [creationStartTime, setCreationStartTime]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (creationStartTime) {
        setElapsedTime(Math.floor((Date.now() - creationStartTime) / 1000));
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [creationStartTime]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const hasNonEmptyValues = useCallback((params) => {
    if (!params || typeof params !== 'object') return false;
    return Object.values(params).some((v) => {
      if (typeof v === 'string') {
        return v.trim() !== '';
      }
      if (typeof v === 'object' && v !== null) {
        return (v.value?.trim?.() || '') !== '';
      }
      return false;
    });
  }, []);

  const prescriptionProgress = useMemo(() => {
    const sections = [
      { name: "Vitals", done: hasNonEmptyValues(metrics) },
      { name: "Symptoms", done: symptoms?.length > 0 },
      { name: "Prakriti", done: (Prakriti_details?.vata + Prakriti_details?.pitta + Prakriti_details?.kapha) === 100 },
      { name: "History", done: diseases?.length > 0 || familyHistory?.some(f => f.disease?.trim() !== "") },
      { name: "Medicines", done: Medicineinputs?.some(m => m.medicine?.trim() !== "" || m.id) },
      { name: "Diet", done: FoodtobeTaken?.length > 0 || selectedRecipes?.length > 0 }
    ];
    const completed = sections.filter(s => s.done).length;
    return Math.round((completed / sections.length) * 100);
  }, [metrics, symptoms, Prakriti_details, diseases, familyHistory, Medicineinputs, FoodtobeTaken, selectedRecipes, hasNonEmptyValues]);

  const [isPlaying, setIsPlaying] = useState(false);

  const audioRef = useRef(null);

  const [currentTime, setCurrentTime] = useState(0);

  const [duration, setDuration] = useState(0);

  const [originalTranscript, setOriginalTranscript] = useState("");

  const [isTranscriptSet, setIsTranscriptSet] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState('All');

  const [selectedCategories, setSelectedCategories] = useState([]);

  const [hoveredRecipe, setHoveredRecipe] = useState(null);

  const [openAi, setOpenAi] = useState(false);

  const [openAi2, setOpenAi2] = useState(false);

  const [ayurvedaAIdiagnois, setAiDiagnosis] = useState([]);

  const { Products, getProducts, isLoading, getProductsByType, page, setPage, getSearchedResults, SearchResults } = ShopStore();

  const handleOpenDialogAi = () => {
    handleAyurvedaDiagnosisAISuggestion();
    setOpenAi(true);
  };

  const handleOpenDoshaAI = () => {
    handleAyurvedaDoshaDiagnosisAISuggestion();
  }

  const handleCloseDialogAi = () => {
    setOpenAi(false);
  };

  const handleSaveAiDiagnosis = () => {
    setOpenAi(false);
  };

  const [openAiHerbal, setOpenAiHerbal] = useState(false);

  const [ayurvedaAIHerbal, setHerbSuggestions] = useState([]);

  const handleOpenHerbalAi = () => {
    handleHerbSuggestion();
    setOpenAiHerbal(true);
  };

  const handleCloseHerbalAi = () => {
    setOpenAiHerbal(false);
  };

  const allCategories = [
    "Breakfast",
    "Lunch",
    "Dinner",
    "South Indian",
    "North Indian",
    "Veggies",
    "Snacks",
    "Curry",
    "Chutney",
    "Drinks"
  ];

  const handleTranscriptChange = (event) => {
    setTranscript(event.target.value);
  };

  const location = useLocation();

  const navigationType = useNavigationType();

  const handleAudioPlayPause = () => {
    const audio = audioRef.current;

    if (isPlaying) {
      audio.pause();
    } else {
      audio
        .play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch((error) => {
          console.error("Audio play error: ", error);
        });
    }
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  const handleSliderChange = (e) => {
    const newTime = e.target.value;
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const handleAIparametersChange = (index, input, value) => {
    const updated = [...aiParameters];
    updated[index][input] = value;
    setAiParameters(updated);
  };



  const handleGoalToggle2 = (index, checked) => {
    const updated = [...aiParameters];
    updated[index].goal = checked;
    setAiParameters(updated);
  };

  const handleDeleteParam = (index) => {
    const updated = [...aiParameters];
    updated.splice(index, 1);
    setAiParameters(updated);
  };

  const handleOpenDialog = (index) => {
    setSelectedIndex(index);
    setOpen(true);
    if (Products.length === 0) {
      loadMoreProducts();
    }
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedIndex(null);
  };

  const handleOpenDialog2 = (index) => {
    setOpen2(true);
  };

  const handleCloseDialog2 = () => {
    setOpen2(false);
  };

  const handleOpenDialog3 = (index) => {
    setOpen3(true);
  };

  const handleCloseDialog3 = () => {
    setOpen3(false);
  };

  const handleOpenDialog4 = (index) => {
    setOpen4(true);
  };

  const handleCloseDialog4 = () => {
    setOpen4(false);
  };

  const handleSeverityChange = (index, newValue) => {
    const updatedData = symptoms.map((item, i) =>
      i === index ? { ...item, severity: newValue } : item
    );
    setSymptoms(updatedData);
  };

  const getGoal = async () => {
    try {

      if (selectedPrescription?.ChiefComplaints?.length > 0) {
        if (symptoms?.length === 0) {
          setSymptoms(selectedPrescription?.ChiefComplaints);
        }
        return;
      }

      const goalRes = await profileModel.get(`/getGoal/${selectedPatientdetails?.UID}`);

      const previousGoals = goalRes?.SymptomsList || [];

      if (goalRes.status === 200 && Array.isArray(previousGoals) && previousGoals.length > 0) {
        if (symptoms && symptoms?.length === 0) {
          setSymptoms(previousGoals);
        }
      } else {

        const vikritiRes = await profileModel.get(`/Vikriti/${selectedPatientdetails?.UID}`);
        if (vikritiRes.status === 200 && Array.isArray(vikritiRes.data?.vikritiList)) {
          if (symptoms && symptoms?.length === 0) {
            setSymptoms(vikritiRes.data.vikritiList);
          }
        }
      }

    } catch (err) {
      console.log("Error fetching goals:", err?.response?.data);
      try {
        const vikritiRes = await profileModel.get(`/Vikriti/${selectedPatientdetails?.UID}`);
        if (vikritiRes.status === 200 && Array.isArray(vikritiRes.data?.vikritiList)) {
          if (symptoms?.length === 0) {
            setSymptoms(vikritiRes.data.vikritiList);
          }
        }
      } catch (vikritiErr) {
        console.error("Error fetching Vikriti:", vikritiErr?.response?.data);
      }
    }
  };

  const handleSelectProduct = (product) => {
    if (selectedIndex !== null) {
      if (selectedIndex === product?.id) {
        handleInputChange(selectedIndex, "", "medicine");
        handleInputChange(selectedIndex, "", "id");
        handleInputChange(selectedIndex, null, "companyid");
        handleInputChange(selectedIndex, null, "deliverycharges");
        handleInputChange(selectedIndex, null, "sku");
        handleInputChange(selectedIndex, null, "price");
        handleInputChange(selectedIndex, null, "desc");
        handleInputChange(selectedIndex, null, "qty");
        handleInputChange(selectedIndex, null, "imgurl");
        handleInputChange(selectedIndex, null, "company");
      } else {
        handleInputChange(selectedIndex, product?.name, "medicine");
        handleInputChange(selectedIndex, String(product?.id ?? ""), "id");
        handleInputChange(selectedIndex, product?.company_id, "companyid");
        handleInputChange(
          selectedIndex,
          product?.deliverycharges,
          "deliverycharges"
        );
        handleInputChange(selectedIndex, product?.sku, "sku");
        handleInputChange(selectedIndex, product?.price, "price");
        handleInputChange(selectedIndex, product?.desc, "desc");
        handleInputChange(selectedIndex, product?.qty, "qty");
        handleInputChange(selectedIndex, product?.imgurl, "imgurl");
        handleInputChange(selectedIndex, product?.company, "company");
      }
    }

    handleCloseDialog();
  };

  const removeSelectedProduct = (index) => {
    handleInputChange(index, "", "medicine");
    handleInputChange(index, "", "id");
    handleInputChange(index, null, "companyid");
    handleInputChange(index, null, "deliverycharges");
    handleInputChange(index, null, "sku");
    handleInputChange(index, null, "price");
    handleInputChange(index, null, "desc");
    handleInputChange(index, null, "qty");
    handleInputChange(index, null, "imgurl");
    handleInputChange(index, null, "company");
  };

  const [acknowledge, setacknowledge] = useState(false);
  const [userProfileloading, setuserProfileloading] = useState(false)

  const [openRecipeAI, setOpenRecipeAI] = useState(false);

  const [loading, setLoading] = useState(false);
  const [dietLoading, setDietLoading] = useState(false);
  const [diagnosisLoading, setDiagnosisLoading] = useState(false);
  const [doshaLoading, setDoshaLoading] = useState(false);

  const [lifestylechangesloading, setlifestylechangesloading] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(null);

  const [Search, setsearch] = useState("");

  const [dialogParamKey, setDialogParamKey] = useState(null);

  const currentParam = useMemo(
    () => Ayurvedaparameters?.find(p => p.parameter === dialogParamKey) || null,
    [Ayurvedaparameters, dialogParamKey]
  );

  const closeDialog = () => setDialogParamKey(null);

  const handleAddField = () => {
    setMedicineinputs([
      ...Medicineinputs,
      {
        medicine: "",
        dose: "",
        Reason: "",
        instruction: "",
        duration: "",
        quantity: 1,
        id: "",
        timing: "",
      },
    ]);
  };

  const handleSearchChange = (e, value) => {
    const searchTerm = value?.toLowerCase() || "";
    setSearchTerm(searchTerm);
  };

  const handleInputChange = (index, inputValue, field) => {
    setMedicineinputs((prevInputs) => {
      const newInputs = [...prevInputs];
      if (inputValue === null) {
        delete newInputs[index][field];
      } else {
        newInputs[index][field] = field === "id" ? String(inputValue ?? "") : inputValue;
      }

      return newInputs;
    });
  };

  const doctorDetailsCookie = Cookies.get("Doctor_details");

  let Doctor_details = {};

  if (doctorDetailsCookie) {
    try {
      Doctor_details = JSON?.parse(doctorDetailsCookie);
    } catch (error) {
      console.log("Error parsing Doctor_details cookie:", error);
    }
  }

  function calculateAverageSeverity(severityMap) {
    const maxSeverityPerSymptom = 5;
    const totalSymptoms = severityMap.length;
    const maxTotalScore = totalSymptoms * maxSeverityPerSymptom;

    const totalSeverityScore = severityMap.reduce(
      (sum, e) => sum + e.severity,
      0
    );

    if (totalSymptoms === 0 || totalSeverityScore === 0) return 100;

    return Math.round((1 - totalSeverityScore / maxTotalScore) * 100);
  };

  const handleMedicaldetails = (name, value) => {
    setMedicaldetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRemoveField = (index) => {
    const newInputs = Medicineinputs.filter((_, i) => i !== index);
    setMedicineinputs(newInputs);
  };

  const getherbalProducts = async () => {
    setLoading(true);
    try {
      const res = await shopModel.get("/getAllproducts");
      if (res.status === 200) {
        setHerbalProducts(res.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const groupByCategory = (items) => {
    return items?.reduce((acc, item) => {
      if (!acc[item.categoryEng]) {
        acc[item.categoryEng] = [];
      }
      acc[item.categoryEng].push(item);
      return acc;
    }, {});
  };

  const getAllDiet = async () => {
    try {
      let res = await profileModel.get("/AllDiet");
      if (res.status === 200) {
        setAllDiet(groupByCategory(res?.data));
        setAllrawDiet(res.data)
      }
    } catch (err) {
      console.log(err?.response?.data);
    }
  };

  const getAllRecipes = async () => {
    try {
      let res = await profileModel.get("/AllRecipes");
      if (res?.status === 200) {
        setAllRecipes(res?.data);
      }
    } catch (err) {
      console.log(err?.response?.data);
    }
  };

  const getRecipesRecommendations = async () => {
    try {
      let res = await profileModel.post("/getRecipiesRecommendations", {
        id: selectedPatientdetails.UID,
      });

      if (res.status === 200) {
        setRecipes(res.data);
        setRecipeAIRecommendation(res.data); // Synchronize both if intended
      }

    } catch (err) {
      console.log(err);
    }
  };

  const getlifestylePractices = async () => {
    try {
      let res = await profileModel.get("/getlifestylePractices");
      if (res.status === 200) {
        setPractices(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCheckboxChange = (item, isChecked, type) => {
    if (type === "included") {
      setFoodtobetaken((prevState) =>
        isChecked
          ? [...prevState, item]
          : prevState.filter((i) => i.id !== item.id)
      );
    } else if (type === "avoided") {
      setFoodtobeAvoided((prevState) =>
        isChecked
          ? [...prevState, item]
          : prevState.filter((i) => i.id !== item.id)
      );
    }
  };
  const getPatientProfile = async () => {
    try {
      let res = await teleConsultationModel.post("getClinicalPatientProfile", {
        id: selectedPatientdetails?.Appointment_id,
      });
      if (res.status == 200) {
        setPatientProfile(res.data);
        setuserProfileloading(true)
      }
    } catch (err) {
      setuserProfileloading(false)
      console.log(err);
    }
  };

  const getPrakritiData = async () => {
    try {
      let res = await profileModel.get(`/GetPrakritidata/${selectedPatientdetails?.UID}`);
      if (res.status === 200) {
        setPrakritiDetails(res.data)
      }
    } catch (err) {
      console.log(err?.response?.data);
    }
  };

  function findVPKResult(arrayList) {
    try {
      const doshaMap = ["Vata", "Pitta", "Kapha"];

      const valuesWithDoshas = arrayList.map((value, index) => ({
        value: value || 0,
        label: doshaMap[index],
      }));

      const sorted = [...valuesWithDoshas].sort((a, b) => b.value - a.value);

      const v = sorted[0];
      const p = sorted[1];
      const k = sorted[2];

      if (v.value - p.value > 20) {
        return v.label;
      } else if (v.value - p.value <= 20 && p.value - k.value > 5) {
        return `${v.label} ${p.label}`;
      } else {
        return `${v.label} ${p.label} ${k.label}`;
      }
    } catch (error) {
      console.error("Error in findVPKResult:", error);
      return null;
    }
  }

  const handleKeyPress = (event) => {
    const charCode = event?.charCode;
    if (event?.keyCode !== 8 && (charCode < 48 || charCode > 57)) {
      event?.preventDefault();
    }
  };

  useEffect(() => {
    if (herbalProducts.length === 0) getherbalProducts();
    if (Object.keys(AllDiet).length === 0) getAllDiet();
    if (AllRecipes.length === 0) getAllRecipes();
    if (Practices.length === 0) getlifestylePractices();
    getRecipesRecommendations();


    if (!patientProfile) getPatientProfile();
    if (!Prakriti_details) getPrakritiData();


    if (!Medicaldetails?.diagnosis) getGoal();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (Search.trim()) {
        getSearchedResults(Search);
      }
    }, 500); // Debounce for 500ms

    return () => clearTimeout(delayDebounceFn);
  }, [Search]);


  const parseAndCalculateBMI = (details) => {
    let heightInCm = 0;
    let weightInKg = 0;


    if (details.height_unit === "ft") {
      const ft = parseFloat(details.height_ft) || 0;
      const inch = parseFloat(details.height_in) || 0;
      heightInCm = ft * 30.48 + inch * 2.54;
    } else if (details.height_unit === "cm") {
      heightInCm = parseFloat(details.height_cm) || 0;
    }

    if (details.weight_unit === "lbs") {
      weightInKg = parseFloat(details.weight_lbs) || 0 * 0.453592;
    } else if (details.weight_unit === "kg") {
      weightInKg = parseFloat(details.weight_kg) || 0;
    }

    const heightInMeters = heightInCm / 100;
    const bmi = (heightInCm > 0 && weightInKg > 0)
      ? (weightInKg / (heightInMeters * heightInMeters)).toFixed(2)
      : "";

    return {
      ...details,
      height: heightInCm > 0 ? heightInCm.toFixed(2) : "",
      weight: weightInKg > 0 ? weightInKg.toFixed(2) : "",
      bmi,
    };
  };

  const handlePatientDetailChanges = (e, field) => {
    const value = e.target.value;
    const updated = {
      ...selectedPatientdetails,
      [field]: value,
    };

    const withBMI = parseAndCalculateBMI(updated);

    setSelectedPatientdetails(withBMI);
  };

  useEffect(() => {

    if (!selectedPatientdetails) return;

    const { height, weight } = selectedPatientdetails;

    const isParsed = selectedPatientdetails?.bmi && !isNaN(Number(height)) && !isNaN(Number(weight));
    if (isParsed) return;

    const heightMatch = typeof height === 'string'
      ? height.match(/(\d+)\s*feet\s*(\d*)\s*inches?/i)
      : null;

    const weightMatch = typeof weight === 'string'
      ? weight.match(/([\d.]+)\s*kg/i)
      : null;

    const updated = {
      ...selectedPatientdetails,
      height_unit: heightMatch ? "ft" : "cm",
      height_ft: heightMatch ? heightMatch[1] : "",
      height_in: heightMatch ? heightMatch[2] : "",
      height_cm: !heightMatch && typeof height === "number" ? height : "",
      weight_unit: "kg",
      weight_kg: weightMatch ? weightMatch[1] : typeof weight === "number" ? weight : "",
    };

    const recalculated = parseAndCalculateBMI(updated);

    setSelectedPatientdetails(recalculated);

  }, []);


  const options = useMemo(() => {
    return (SearchResults || [])
      .filter((item) => item?.onsale === true)
      .flatMap((product) => {
        const variants = product?.other_info?.variants || [];

        if (variants.length <= 1) {
          const v = variants.length === 1 ? variants[0] : null;
          return [{
            ...product,
            id: String(product?.id ?? product?._id ?? ""),
            name: product?.name ?? product?.medicine ?? "",
            price: v ? (v?.price ?? product?.price ?? 0) : (product?.price ?? 0),
            isVariant: false,
          }];
        }

        return variants.map((v) => ({
          ...product,
          id: String(v?.id ?? v?._id ?? ""),
          parentId: String(product?.id ?? product?._id ?? ""),
          price: v?.price ?? product?.price ?? 0,
          name: `${product?.name ?? product?.medicine ?? ""} - ${v?.title ?? ""}`.trim(),
          variantTitle: v?.title,
          isVariant: true,
        }));
      });
  }, [SearchResults]);

  const handleSymptomChange = (index, newSymptom) => {
    const updatedData = [...symptoms];
    updatedData[index].symptoms = newSymptom;
    setSymptoms(updatedData);
  };

  const handleAddRow = () => {
    setSymptoms([...symptoms, { symptoms: "", severity: 0 }]);
  };

  const handleDeleteRow = (index) => {
    const updatedData = symptoms.filter((_, i) => i !== index);
    setSymptoms(updatedData);
  };

  const handleMetricChange = (key, value) => {
    setMetrics((prev) => ({ ...prev, [key]: value }));
  };

  const handleCustomMetricChange = (index, field, value) => {
    const updatedCustomMetrics = [...customMetrics];
    updatedCustomMetrics[index][field] = value;
    setCustomMetrics(updatedCustomMetrics);
  };

  const handleAddCustomMetric = () => {
    setCustomMetrics([...customMetrics, { key: "", value: "" }]);
  };

  const handleDeleteCustomMetric = (index) => {
    setCustomMetrics(customMetrics.filter((_, i) => i !== index));
  };

  const handleSelectMultipleProducts = (product, variant = null) => {
    let finalProduct;
    const variants = product?.other_info?.variants || [];

    if (variant && variants.length > 1) {
      finalProduct = {
        ...product,
        price: variant.price,
        name: `${product.name} - ${variant.title}`,
        variantTitle: variant.title,
        isVariant: true
      };
    } else if (product.isVariant) {
      finalProduct = product;
    } else if (variants.length === 1) {
      // If only one variant exists, auto-select it but do not append title
      const v = variants[0];
      finalProduct = {
        ...product,
        price: v.price ?? product.price,
        name: product.name,
        isVariant: false
      };
    } else {
      finalProduct = product;
    }

    const existingIndex = Medicineinputs.findIndex((item) => item.id === finalProduct.id);

    if (existingIndex !== -1) {
      const updated = Medicineinputs.filter((item) => item.id !== finalProduct.id);
      setMedicineinputs(updated);
      return;
    }

    const emptyIndex = Medicineinputs.findIndex((item) => !item.id && !item.medicine);

    if (emptyIndex !== -1) {
      const updated = Medicineinputs.map((item, index) =>
        index === emptyIndex
          ? {
            ...item,
            id: String(finalProduct.id ?? ""),
            medicine: finalProduct.name || finalProduct.medicine,
            companyid: finalProduct.company_id,
            deliverycharges: finalProduct.deliverycharges,
            sku: finalProduct.sku,
            price: finalProduct.price,
            desc: finalProduct.desc,
            qty: finalProduct.qty,
            imgurl: finalProduct.imgurl,
            company: finalProduct.company,
            quantity: 1,
          }
          : item
      );
      setMedicineinputs(updated);
      return;
    }

    const updated = [
      ...Medicineinputs,
      {
        id: String(finalProduct.id ?? ""),
        medicine: finalProduct.name || finalProduct.medicine,
        companyid: finalProduct.company_id,
        deliverycharges: finalProduct.deliverycharges,
        sku: finalProduct.sku,
        price: finalProduct.price,
        desc: finalProduct.desc,
        qty: finalProduct.qty,
        imgurl: finalProduct.imgurl,
        company: finalProduct.company,
        quantity: 1,
        Reason: "",
        dose: "",
        instruction: "",
        duration: "",
        timing: "",
      },
    ];

    setMedicineinputs(updated);
  };

  const [newTest, setNewTest] = useState("");

  const suggestions = [
    "Blood Test",
    "Urine Test",
    "MRI",
    "X-Ray",
    "Liver Function Test",
    "Kidney Function Test",
    "Thyroid Test",
    "Complete Blood Count (CBC)",
    "Hemoglobin Test",
    "Cholesterol Test",
    "Blood Sugar Test",
    "Vitamin D Test",
    "Electrolyte Panel",
    "Lipid Profile",
    "HIV Test",
    "Hepatitis Test",
    "Pregnancy Test",
    "Urinalysis",
    "Prostate Specific Antigen (PSA) Test",
    "Blood Culture",
    "Calcium Test",
    "Blood Coagulation Test (PT, APTT)",
    "Chest X-Ray",
    "Ultrasound Scan",
    "ECG (Electrocardiogram)",
    "Echocardiogram",
    "Barium Swallow Test",
    "CT Scan",
    "Endoscopy",
    "Arterial Blood Gas Test",
    "Pulmonary Function Test",
    "Sputum Test",
    "Skin Biopsy",
    "Bone Density Test",
    "Genetic Testing",
    "Allergy Test",
    "C-Reactive Protein (CRP) Test",
    "Lactate Dehydrogenase (LDH) Test",
    "Creatinine Test",
    "Bilirubin Test",
    "Amylase and Lipase Test",
    "Vitamin B12 Test",
    "Iron Studies",
    "Magnesium Test",
    "HBA1c (Hemoglobin A1c) Test",
    "Hepatitis C Test",
    "Pap Smear",
    "Colonoscopy",
    "BMD (Bone Mineral Density) Test",
    "Stool Test",
    "Urine Culture Test",
    "Saliva Test",
    "Fertility Test",
    "STD Test",
    "Sickle Cell Test",
    "Toxoplasmosis Test",
    "Dengue Test",
    "Malaria Test",
    "Tuberculosis (TB) Test",
    "Zika Virus Test",
    "COVID-19 Test",
  ];

  const handleAddTest = () => {
    if (newTest) {
      setLabTests([...labTests, newTest]);
      setNewTest("");
    }
  };

  const handleRemoveTest = (index) => {
    const updatedTests = [...labTests];
    updatedTests.splice(index, 1);
    setLabTests(updatedTests);
  };

  const combinedMetrics = {
    ...metrics,
    ...Object?.fromEntries(
      customMetrics?.map((metric) => [metric.key, metric.value])
    ),
  };

  function isDoshamEmpty(dosham) {

    const isEmptyArray = (arr) => Array.isArray(arr) && arr.length === 0;
    const isEmptyObject = (obj) => obj && Object.keys(obj).length === 0;

    return (
      isEmptyArray(dosham.Increased.doshas) &&
      isEmptyObject(dosham.Increased.percentage) &&
      isEmptyObject(dosham.Increased.intensity) &&
      isEmptyArray(dosham.Decreased.doshas) &&
      isEmptyObject(dosham.Decreased.percentage) &&
      isEmptyObject(dosham.Decreased.intensity)
    );
  };

  function hasFamilyHistoryDetails(familyHistory) {
    return familyHistory.some(entry => {
      return (entry.disease && entry.disease.trim() !== '') ||
        (entry.duration && entry.duration.trim() !== '');
    });
  }

  const updatePrakritiResult = async (prakritiResult) => {
    try {

      if (!prakritiResult || !selectedPatientdetails?.UID) {
        throw new Error("Missing prakritiResult or UID");
      }

      const {
        vata = 0,
        pitta = 0,
        kapha = 0,
        vScore = 0,
        pScore = 0,
        kScore = 0,
        PrakritiCollection = []
      } = prakritiResult;

      const result = findVPKResult([vata, pitta, kapha]);

      const payload = {
        UID: selectedPatientdetails.UID,
        id: selectedPatientdetails.UID,
        result,
        date: Date.now().toString(),
        vata: Math.round(vata),
        pitta: Math.round(pitta),
        kapha: Math.round(kapha),
        rawVata: vScore,
        rawPitta: pScore,
        rawKapha: kScore,
        PrakritiCollection
      };

      await profileModel.post("/UpdateClinicalPrakriti", payload);

    } catch (err) {
      console.error("Error updating Prakriti result:", err?.response?.data || err);
    }
  };

  const handlesubmitPrescription = async (draftStatus) => {
    try {

      if (!acknowledge) {
        toast.info(
          "Please check the acknowledgment checkbox before proceeding",
          {
            position: "top-center",
            limit: 1,
            transition: Zoom,
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          }
        );

        return;
      }

      setLoading(true);


      const goalsetting = [...(symptoms || []),
      ...(aiParameters || []).map((e) => ({
        symptoms: e.name,
        severity: e?.severity,
        goal: e?.goal || false
      }))].filter((e) => e?.goal)

      console.log("DEBUG: selectedPatientdetails =", selectedPatientdetails);
      
      // Ensure UID is preserved
      const finalPatientDetails = { ...selectedPatientdetails };
      if (!finalPatientDetails.UID && finalPatientDetails.uid) {
        finalPatientDetails.UID = finalPatientDetails.uid;
      }
      if (!finalPatientDetails.UID && finalPatientDetails.PID) {
        finalPatientDetails.UID = finalPatientDetails.PID;
      }

      let payload = {
        isFollowUpEdit,
        Prescription_id: selectedPrescription?.id,
        MenstrualDetails: formData,
        Patient_details: finalPatientDetails,
        Doctor_details: Cookies.get('Doctor_details') ? JSON.parse(Cookies.get('Doctor_details')) : Doctor_details,
        Supplements: (Medicineinputs || []).filter(({ quantity, ...rest }) => Object.values(rest).some(val => typeof val === 'string' ? val.trim() !== '' : val !== null && val !== undefined)),
        Medical_details: Medicaldetails,
        AyurvedaParameters: Ayurvedaparameters,
        transcript: transcript,
        Diet: {
          included: FoodtobeTaken || [],
          avoided: Foodtobeavoided || [],
        },
        VitalSigns: combinedMetrics,
        Goals: goalsetting,
        labTests: labTests || [],
        PrakritiDetails: Prakriti_details || {},
        VikritiDetails: Dosham || {},
        familyHistory: familyHistory || [],
        currentDrugs: currentDrugs || [],
        complications: complications || [],
        habits: habits || [],
        Follow_up: FollowUp || "",
        Practices: {
          yoga: Object.values(yogalist || {}),
          pranayama: Object.values(pranayama || {}),
          meditation: Object.values(meditationList || {}),
        },
        // RecipesRecommendations: selectedRecipes,
        Recipes: selectedRecipes || [],
        draftStatus,
        DietRecommendations: {
          Suitable: FoodtobeTaken || [],
          Not_Suitable: Foodtobeavoided || [],
        },
        PastHistory: diseases || [],
        AI_Reports: aiParameters || [],
        ChiefComplaints: symptoms || [],
        YogaRecommendations: Object.values(yogalist || {}),
        PranayamaRecommendations: Object.values(pranayama || {}),
        LifeStyle_changes: lifestylechanges ? lifestylechanges.split('\n').filter(item => item.trim() !== '') : [],
      };


      if (audioBase64 || audioBase64?.trim() !== "") {
        payload.audio = audioBase64?.replace("data:", "")?.replace(/^.+,/, "");
      }

      let res = await kioskModel.post(
        `/api/v1/UploaddiabetesPrescription`,
        payload
      );

      if (res.status === 200) {

        if (draftStatus) {

          toast.success("Draft Saved Successfully", {
            position: "top-center",
            limit: 1,
            transition: Zoom,
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } else {
          toast.success("Completed Appointment Successfully", {
            position: "top-center",
            limit: 1,
            transition: Zoom,
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });

        }

        UpdateVikritifromtheList();

        updatePrakritiResult(Prakriti_details)

        clearReportsStore();

        resetPrescriptionState();

        setPrescription(res.data);

        hasPushed.current = true;

        setShouldNavigate(true);

        setTimeout(() => {
          navigate("/ViewPrescription", { replace: true });
        }, 1500);

      }

    }

    catch (error) {
      console.log(error?.response?.data || error);
    }

    finally {
      setLoading(false);
    }

  };

  const isEmptyObject = (obj) =>
    obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;

  const getKey = (p) => (p?.id ?? p?.name ?? JSON.stringify(p)).toString().trim().toLowerCase();

  const collectParamsFromReports = (Reports) => {
    const all = [];
    Reports?.forEach((reportItem) => {
      reportItem?.Reports?.forEach((report) => {
        try {
          const analysis = JSON.parse(report?.ai_analysis || "{}");
          const abnormal = analysis?.abnormal_parameters || [];
          const normal = analysis?.normal_parameters || [];
          all.push(...abnormal);
        } catch (err) {
          console.error("Error parsing ai_analysis:", err);
        }
      });
    });
    return all;
  };

  const buildAiParameters = ({ selectedPrescription, Reports, aiParameters }) => {

    const base = Array.isArray(selectedPrescription?.AI_Reports)
      ? selectedPrescription.AI_Reports
      : [];

    const fromReports = collectParamsFromReports(Reports);

    const existingByKey = new Map((aiParameters ?? []).map(p => [getKey(p), p]));
    const baseByKey = new Map(base.map(p => [getKey(p), p]));

    // Items from prescription, with local state (like goal) preserved if exists
    const normalizedBase = base.map((p) => {
      const k = getKey(p);
      const existing = existingByKey.get(k);
      return {
        ...p,
        goal: typeof (existing?.goal ?? p.goal) === "boolean"
          ? (existing?.goal ?? p.goal)
          : false,
      };
    });

    const extraLocals = (aiParameters ?? []).filter(p => !baseByKey.has(getKey(p)));
    const combinedExisting = [...normalizedBase, ...extraLocals];
    const combinedExistingByKey = new Map(combinedExisting.map(p => [getKey(p), p]));

    const newOnes = fromReports.filter((p) => {
      const k = getKey(p);
      return !combinedExistingByKey.has(k);
    }).map((p) => ({
      ...p,
      goal: typeof p.goal === "boolean" ? p.goal : false,
    }));

    return [...combinedExisting, ...newOnes];
  };

  useEffect(() => {
    if (selectedPatientdetails?.UID) {
      getPulseDetails(selectedPatientdetails.UID);
    }
  }, [selectedPatientdetails?.UID]);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        if ((complications && complications.length > 0) && (symptoms && symptoms.length > 0)) return;
        if (selectedPatientdetails?.UID) {
          const res = await kioskModel.get(`/api/v1/clinical/diabetes/user-answers/${selectedPatientdetails.UID}`);
          if (res.status === 200 && res.data) {
            if (!complications || complications.length === 0) {
              const complicationsStr = res.data.complications || "";
              const complicationsArray = complicationsStr
                ? complicationsStr.split(",").map((s) => s.trim()).filter((s) => s.length > 0)
                : [];
              if (complicationsArray.length > 0) {
                setComplications(complicationsArray.map((item) => ({ complication: item, severity: 0 })));
              }
            }
            if (!symptoms || symptoms.length === 0) {
              const symptomsStr = res.data.symptoms || "";
              const symptomsArray = symptomsStr
                ? symptomsStr.split(",").map((s) => s.trim()).filter((s) => s.length > 0)
                : [];
              if (symptomsArray.length > 0) {
                setSymptoms(symptomsArray.map((item) => ({ symptoms: item, severity: 0 })));
              }
            }
            if (!habits || habits.length === 0) {
              const habitsStr = res.data.habits || "";
              const habitsArray = habitsStr
                ? habitsStr.split(",").map((s) => s.trim()).filter((s) => s.length > 0)
                : [];
              if (habitsArray.length > 0) {
                setHabits(habitsArray.map((item) => ({ habit: item, severity: 0, duration: "" })));
              }
            }
          }
        }
      } catch (err) {
        console.error("Error fetching profile data:", err);
      }
    };
    fetchProfileData();
  }, [selectedPatientdetails?.UID, complications, setComplications, symptoms, setSymptoms, habits, setHabits]);

  const handleAddComplication = () => {
    setComplications([...(complications || []), { complication: "", severity: 0 }]);
  };

  const handleDeleteComplication = (index) => {
    const newComplications = [...(complications || [])];
    newComplications.splice(index, 1);
    setComplications(newComplications);
  };

  const handleComplicationChange = (index, value) => {
    const newComplications = [...(complications || [])];
    if (typeof newComplications[index] === 'string') {
      newComplications[index] = { complication: value, severity: 0 };
    } else {
      newComplications[index] = { ...newComplications[index], complication: value };
    }
    setComplications(newComplications);
  };

  const handleComplicationSeverityChange = (index, value) => {
    const newComplications = [...(complications || [])];
    if (typeof newComplications[index] === 'string') {
      newComplications[index] = { complication: newComplications[index], severity: value };
    } else {
      newComplications[index] = { ...newComplications[index], severity: value };
    }
    setComplications(newComplications);
  };

  const handleAddHabit = () => {
    setHabits([...(habits || []), { habit: "", severity: 0, duration: "" }]);
  };

  const handleDeleteHabit = (index) => {
    const newHabits = [...(habits || [])];
    newHabits.splice(index, 1);
    setHabits(newHabits);
  };

  const handleHabitChange = (index, value) => {
    const newHabits = [...(habits || [])];
    if (typeof newHabits[index] === 'string') {
      newHabits[index] = { habit: value, severity: 0, duration: "" };
    } else {
      newHabits[index] = { ...newHabits[index], habit: value };
    }
    setHabits(newHabits);
  };

  const handleHabitSeverityChange = (index, value) => {
    const newHabits = [...(habits || [])];
    if (typeof newHabits[index] === 'string') {
      newHabits[index] = { habit: newHabits[index], severity: value, duration: "" };
    } else {
      newHabits[index] = { ...newHabits[index], severity: value };
    }
    setHabits(newHabits);
  };

  const handleHabitDurationChange = (index, value) => {
    const newHabits = [...(habits || [])];
    if (typeof newHabits[index] === 'string') {
      newHabits[index] = { habit: newHabits[index], severity: 0, duration: value };
    } else {
      newHabits[index] = { ...newHabits[index], duration: value };
    }
    setHabits(newHabits);
  };

  useEffect(() => {
    if (!selectedPrescription && selectedPatientdetails && (!metrics || !hasNonEmptyValues(metrics))) {
      // The most recent digital parameters are merged directly into selectedPatientdetails in Patient_Profile.jsx
      if (selectedPatientdetails?.systolic || selectedPatientdetails?.pulse || selectedPatientdetails?.rbs || selectedPatientdetails?.spo2 || selectedPatientdetails?.gripStrength) {
        setMetrics({
          bloodPressure: selectedPatientdetails?.systolic && selectedPatientdetails?.diastolic ? `${selectedPatientdetails.systolic}/${selectedPatientdetails.diastolic}` : "",
          randomBloodSugar: selectedPatientdetails?.rbs ? String(selectedPatientdetails.rbs) : "",
          pulseRate: selectedPatientdetails?.pulse ? String(selectedPatientdetails.pulse) : "",
          oximeterValue: selectedPatientdetails?.spo2 ? String(selectedPatientdetails.spo2) : "",
          gripStrength: selectedPatientdetails?.gripStrength ? String(selectedPatientdetails.gripStrength) : "",
        });
      }
    }
  }, [selectedPrescription, selectedPatientdetails, metrics, setMetrics, hasNonEmptyValues]);

  useEffect(() => {
    if (!selectedPrescription && selectedPatientdetails?.Vikriti_details) {
      if (Dosham && isDoshamEmpty(Dosham)) {
        const resultText = selectedPatientdetails.Vikriti_details.Result?.toLowerCase() || "";
        const increasedDoshas = [];
        if (resultText.includes('v') || resultText.includes('vata')) increasedDoshas.push('vata');
        if (resultText.includes('p') || resultText.includes('pitta')) increasedDoshas.push('pitta');
        if (resultText.includes('k') || resultText.includes('kapha')) increasedDoshas.push('kapha');

        setDosham({
          ...Dosham,
          Increased: {
            ...Dosham.Increased,
            doshas: increasedDoshas,
          },
          Reason: selectedPatientdetails.Vikriti_details.reason || ""
        });
      }
    }
  }, [selectedPrescription, selectedPatientdetails, Dosham, setDosham]);

  useEffect(() => {

    if (selectedPrescription) {

      setSelectedPatientdetails(selectedPrescription?.Patient_details)

      setMedicaldetails(
        hasNonEmptyValues(Medicaldetails)
          ? Medicaldetails
          : selectedPrescription.Medical_details
      );

      if (selectedPrescription?.PastHistory?.length > 0 && (!diseases || diseases?.length === 0)) {
        setDiseases(selectedPrescription?.PastHistory);
      }

      setAyurvedaparameters(
        hasNonEmptyValues(Ayurvedaparameters)
          ? Ayurvedaparameters
          : (
            selectedPrescription?.AyurvedaParameters?.every(item => item?.questions)
              ? selectedPrescription?.AyurvedaParameters?.map(item => ({
                ...item,
                questions: item?.questions?.map(q => ({ ...q, answer: q?.answer ?? '' })) || []
              }))
              : Object.values(ayurvedaAssessments ?? {}).map(assessment => ({
                ...assessment,
                value: '',
                questions: assessment?.questions?.map(q => ({ ...q, answer: '' })) || []
              }))
          )
      );

      if (selectedPrescription?.ChiefComplaints?.length > 0 && (!symptoms || symptoms?.length === 0)) {
        setSymptoms(selectedPrescription?.ChiefComplaints);
      }

      if (Dosham && isDoshamEmpty(Dosham)) {
        setDosham(selectedPrescription?.VikritiDetails || {
          Increased: {
            doshas: [],
            percentage: {},
            intensity: {},
          },
          Decreased: {
            doshas: [],
            percentage: {},
            intensity: {},
          },
        })
      }

      if (!hasFamilyHistoryDetails(familyHistory)) {
        setFamilyHistory(
          selectedPrescription?.familyHistory || [
            { relation: 'Father', disease: '', duration: '' },
            { relation: 'Mother', disease: '', duration: '' }
          ]
        );
      }

      if (selectedPrescription?.MenstrualDetails && Object.keys(formData || {}).length === 0) {
        setFormData(selectedPrescription.MenstrualDetails);
      }

      if (labTests && labTests?.length === 0) {
        setLabTests(selectedPrescription?.labTests || []);
      }

      if (Medicineinputs && Medicineinputs.every(e => e?.medicine?.trim() === '')) {
        setMedicineinputs(
          (selectedPrescription?.Supplements || []).map(s => ({
            ...s,
            id: String(s.id ?? "")
          })) || [
            {
              medicine: "",
              Reason: "",
              dose: "",
              instruction: "",
              duration: "",
              quantity: 1,
              id: "",
              timing: "",
            },
          ]
        );
      }

      if (FoodtobeTaken && FoodtobeTaken?.length === 0) {
        setFoodtobetaken(selectedPrescription?.Diet?.included || []);
      }

      if (Foodtobeavoided && Foodtobeavoided?.length === 0) {
        setFoodtobeAvoided(selectedPrescription?.Diet?.avoided || []);
      }

      if (selectedRecipes && selectedRecipes?.length === 0) {
        setSelectedRecipes(selectedPrescription?.Recipes || []);
      }

      const excludedKeys = [
        "bloodPressure",
        "oximeterValue",
        "pulseRate",
        "randomBloodSugar",
        "bloodSugarType",
        "gripStrength",
      ];

      const allDp = (Array.isArray(selectedPatientdetails?.digital_params) ? selectedPatientdetails?.digital_params : (selectedPatientdetails?.digital_params ? [selectedPatientdetails?.digital_params] : []))
        .filter(Boolean)
        .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
      const recentDp = allDp.length > 0 ? allDp[0] : null;

      setMetrics(
        hasNonEmptyValues(metrics) ?
          metrics :
          selectedPrescription?.VitalSigns || {
            bloodPressure: recentDp?.systolic && recentDp?.diastolic ? `${recentDp.systolic}/${recentDp.diastolic}` : "",
            randomBloodSugar: recentDp?.rbs ? String(recentDp.rbs) : "",
            pulseRate: recentDp?.pulse ? String(recentDp.pulse) : "",
            oximeterValue: recentDp?.spo2 ? String(recentDp.spo2) : "",
            gripStrength: recentDp?.gripStrength ? String(recentDp.gripStrength) : "",
          }
      );

      if (customMetrics && customMetrics?.length === 0) {
        setCustomMetrics(
          selectedPrescription?.VitalSigns
            ? Object.entries(selectedPrescription.VitalSigns)
              .filter(([key]) => !excludedKeys.includes(key))
              .map(([key, value]) => ({ key, value }))
            : []
        );
      }

      if (isEmptyObject(yogalist)) {
        if (
          selectedPrescription?.Practices?.yoga &&
          selectedPrescription?.Practices?.yoga.length > 0
        ) {
          setyogalist(selectedPrescription?.Practices?.yoga)
        }
      }

      if (isEmptyObject(pranayama)) {
        if (
          selectedPrescription?.Practices?.pranayama &&
          selectedPrescription?.Practices?.pranayama.length > 0
        ) {
          setPranayamaList(selectedPrescription?.Practices?.pranayama)
        }
      }

      if (isEmptyObject(meditationList)) {
        if (
          selectedPrescription?.Practices?.meditation &&
          selectedPrescription?.Practices?.meditation.length > 0
        ) {
          setMeditationlist(selectedPrescription?.Practices?.meditation)
        }
      }

      if (
        typeof lifestylechanges !== "string" ||
        lifestylechanges.trim() === ""
      ) {
        const values = Array.isArray(selectedPrescription?.LifeStyle_changes)
          ? selectedPrescription.LifeStyle_changes.join("\n")
          : "";

        if (values) {
          setlifestylechanges(values);
        }
      }


      if (selectedPrescription?.Follow_up && FollowUp === "No") {
        setfollowup(selectedPrescription?.Follow_up);
      }

      if (selectedPrescription?.currentDrugs?.length > 0 && (currentDrugs?.length === 0 || !hasCurrentDrugs(currentDrugs))) {
        setcurrentDrugs(selectedPrescription.currentDrugs);
      }

    }

  }, []);

  useEffect(() => {
    try {
      const next = buildAiParameters({ selectedPrescription, Reports, aiParameters });
      setAiParameters(next);
    } catch (e) {
      console.log("Unexpected error during parameter extraction:", e);
    }
  }, [Reports]);

  useEffect(() => {
    if (transcript) {
      setIsTranscriptSet(true);
    }
  }, [transcript]);

  const uniqueDecreasesDosha = new Set(
    AllRecipes?.flatMap(
      (recipe) =>
        recipe?.info
          ?.split("&")
          .map((dosha) => dosha.trim())
    ) || []
  );

  const handleDiseaseFieldChange = (index, field, value) => {
    setDiseases(prev =>
      prev.map((d, i) =>
        i === index ? { ...d, [field]: value } : d
      )
    );
  };

  const doshaOptions = [
    { code: "V", label: "Vatha" },
    { code: "P", label: "Pitta" },
    { code: "K", label: "Kapha" }
  ];

  const [selectedDoshas, setSelectedDoshas] = useState([]);

  const handleDoshaToggle = (dosha) => {
    setSelectedDoshas((prev) =>
      prev.includes(dosha) ? prev.filter((d) => d !== dosha) : [...prev, dosha]
    );
  };

  const handleCategoryToggle = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };

 const filteredRecipes = (AllRecipes || []).filter((item) => {
  if (!item) return false;

  const itemDoshas = Array.isArray(
    item?.decreasesDosha?.split?.(",")
  )
    ? item.decreasesDosha.split(",").map((d) => d.trim())
    : [];

  const itemCategories = Array.isArray(
    item?.category?.split?.(",")
  )
    ? item.category.split(",").map((c) => c.trim())
    : [];

  const doshaMatch =
    (selectedDoshas || []).length === 0 ||
    (selectedDoshas || []).every((dosha) =>
      (itemDoshas || []).includes(dosha)
    );

  const categoryMatch =
    (selectedCategories || []).length === 0 ||
    (selectedCategories || []).some((cat) =>
      (itemCategories || []).includes(cat)
    );

  return doshaMatch && categoryMatch;
});

  const HerbalmedicinesElementRef = useRef(null);

  const [herbalproducstsloading, setherbalproducstsloading] = useState(false);

  const observer = useRef();

  const lastPostElementRef = useCallback(
    (node) => {
      if (herbalproducstsloading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage();
        }
      });

      if (node) observer.current.observe(node);
    },
    [herbalproducstsloading]
  );

  const loadMoreProducts = async () => {
    setherbalproducstsloading(true);
    getProducts()
    setherbalproducstsloading(false);
  };

  useEffect(() => {
    if (selectedProductCategory === 'All') {
      loadMoreProducts()
    }
    else {
      getProductsByType(selectedProductCategory, "")
    }

  }, [page, selectedProductCategory]);

  const hasCurrentDrugs = (currentDrugs) => {
    return currentDrugs?.some((drug) => drug?.medicine?.trim() !== "" || drug?.dose?.trim() !== "" || drug?.duration?.trim() !== "");
  };

  const formatDiagnosisData = (dataArray) => {
    return dataArray
      .map(
        (item, index) =>
          `Diagnosis ${index + 1}: ${item.ayurveda_diagnosis}\nReason: ${item.reason
          }\n`
      )
      .join("\n");
  };

  const formatDoshaDetails = (type) => {
    return Dosham?.[type]?.doshas?.map((dosha) => {
      const percent = Dosham[type].percentage?.[dosha] || '';
      const intensity = Dosham[type].intensity?.[dosha] || '';
      const details = [];

      if (percent) details.push(`${percent}%`);
      if (intensity) details.push(intensity);

      return `${dosha.charAt(0).toUpperCase() + dosha.slice(1)}${details.length ? ` (${details.join(', ')})` : ''}`;
    }).join(', ');
  };

  const severityMap = {
    0: "None",
    1: "Mild",
    2: "Moderate",
    3: "High",
    4: "Severe",
    5: "Extreme",
  };

  const handleAyurvedaDiagnosisAISuggestion = async () => {
    try {

      setDiagnosisLoading(true);

      const decreasedDetails = formatDoshaDetails('Decreased');
      const increasedDetails = formatDoshaDetails('Increased');

      const symptomsString = symptoms?.length > 0
        ? symptoms
          .map(
            (s) =>
              `${s.symptoms} (Severity: ${severityMap[s.severity] || "N/A"}, Duration: ${s.duration || "N/A"}, Frequency: ${s.frequency || "N/A"})`
          )
          .join(", ")
        : "";

      const diseaseListString =
        diseases.length > 0
          ? diseases
            .map((d) => {
              const ayurveda = d.ayurvedaDisease || "Unknown Ayurveda Name";
              const modern = d.modernDisease || "Unknown Modern Name";
              const duration = d.duration || "N/A";
              const severity = d.severity !== undefined ? severityMap[d.severity] || "N/A" : "N/A";

              return `Ayurveda: ${ayurveda}, Modern: ${modern} (Duration: ${duration}, Severity: ${severity})`;
            })
            .join(", ")
          : "";

      const vikriti = [
        decreasedDetails ? `${decreasedDetails} Decreased` : '',
        increasedDetails ? `${increasedDetails} Increased` : ''
      ].filter(Boolean).join(', ');

      // Ensure UID is preserved
      const aiPatientDetails = { ...selectedPatientdetails };
      if (!aiPatientDetails.UID && aiPatientDetails.uid) aiPatientDetails.UID = aiPatientDetails.uid;
      if (!aiPatientDetails.UID && aiPatientDetails.PID) aiPatientDetails.UID = aiPatientDetails.PID;

      const res = await profileModel.post("/getDiagnosisFromAIWithParam", {
        UID: aiPatientDetails.UID,
        patient_details: aiPatientDetails,
        chief_complaints: symptoms,
        ayurvedic_assessment: Ayurvedaparameters.reduce((acc, p) => ({ ...acc, [p.parameter]: p.value }), {}),
        vital_signs: combinedMetrics,
        prakriti_dosha: patientProfile?.Prakriti_details?.result || {},
        past_history: diseases || [],
        current_drugs: currentDrugs || [],
        ai_reports: aiParameters || [],
        vikriti_dosha: vikriti,
      })

      if (res.status === 200) {

        let cleanData = res?.data?.analysis

        const parsedData = JSON.parse(cleanData);

        console.log(parsedData?.ayurveda_diagnostics);

        setAiDiagnosis(parsedData?.ayurveda_diagnostics);

      }
    } catch (err) {
      console.log("Error fetching AI response:", err);
      setError(err.message || "An error occurred while fetching the AI response.");
    } finally {
      setDiagnosisLoading(false);
    }
  };

  function getDoshamStatus(v, p, k) {
    const Dosham = {
      Increased: {
        doshas: [],
        percentage: {},
        intensity: {},
      },
      Decreased: {
        doshas: [],
        percentage: {},
        intensity: {},
      },
    };

    const mapping = { v: 'vata', p: 'pitta', k: 'kapha' };

    if (v === 1) {
      Dosham.Increased.doshas.push(mapping.v);
      Dosham.Increased.percentage[mapping.v] = "70";
      Dosham.Increased.intensity[mapping.v] = "";
    } else if (v === -1) {
      Dosham.Decreased.doshas.push(mapping.v);
      Dosham.Decreased.percentage[mapping.v] = "70";
      Dosham.Decreased.intensity[mapping.v] = "";
    }

    if (p === 1) {
      Dosham.Increased.doshas.push(mapping.p);
      Dosham.Increased.percentage[mapping.p] = "70";
      Dosham.Increased.intensity[mapping.p] = "";
    } else if (p === -1) {
      Dosham.Decreased.doshas.push(mapping.p);
      Dosham.Decreased.percentage[mapping.p] = "70";
      Dosham.Decreased.intensity[mapping.p] = "";
    }

    if (k === 1) {
      Dosham.Increased.doshas.push(mapping.k);
      Dosham.Increased.percentage[mapping.k] = "70";
      Dosham.Increased.intensity[mapping.k] = "";
    } else if (k === -1) {
      Dosham.Decreased.doshas.push(mapping.k);
      Dosham.Decreased.percentage[mapping.k] = "70";
      Dosham.Decreased.intensity[mapping.k] = "";
    }

    return Dosham;
  };

  function findDominantDoshaWithPercentage(vPercent = 0, pPercent = 0, kPercent = 0) {

    if (vPercent <= 0 && pPercent <= 0 && kPercent <= 0) {
      return null;
    }

    let dominantDosha;
    if (vPercent >= pPercent && vPercent >= kPercent) {
      dominantDosha = "Vata";
    } else if (pPercent >= vPercent && pPercent >= kPercent) {
      dominantDosha = "Pitta";
    } else {
      dominantDosha = "Kapha";
    }


    const dominantPercentage = {
      Vata: vPercent,
      Pitta: pPercent,
      Kapha: kPercent,
    }[dominantDosha];


    return { dosha: dominantDosha, percentage: dominantPercentage };
  };

  function formatDoshaData(Dosham) {

    const fields = { vata: 0, pitta: 0, kapha: 0 };

    for (const dosha of Dosham.Increased?.doshas || []) {
      const val = parseFloat(Dosham.Increased.percentage?.[dosha] || 0);
      fields[dosha] += val;
    }

    for (const dosha of Dosham.Decreased?.doshas || []) {
      const val = parseFloat(Dosham.Decreased.percentage?.[dosha] || 0);
      fields[dosha] -= val;
    }

    return fields;
  };

  const UpdateVikritifromtheList = async () => {
    try {
      const formatedDoshadata = formatDoshaData(Dosham);

      const findDominantDosha = findDominantDoshaWithPercentage(formatedDoshadata?.vata, formatedDoshadata?.pitta, formatedDoshadata?.kapha)

      let res = await profileModel.put('/UpdateVikritiFromList', {

        "UID": selectedPatientdetails?.UID,

        "fields": { ...formatedDoshadata, Result: findDominantDosha?.dosha }

      })

    }
    catch (err) {
      console.log(err.response?.data)
    }
  };

  const handleAyurvedaDoshaDiagnosisAISuggestion = async () => {
    try {
      setDoshaLoading(true);

      const decreasedDetails = formatDoshaDetails('Decreased');
      const increasedDetails = formatDoshaDetails('Increased');

      const symptomsString = symptoms?.length > 0
        ? symptoms
          .map(
            (s) =>
              `${s.symptoms} (Severity: ${severityMap[s.severity] || "N/A"}, Duration: ${s.duration || "N/A"}, Frequency: ${s.frequency || "N/A"})`
          )
          .join(", ")
        : "";

      const vikriti = [
        decreasedDetails ? `${decreasedDetails} Decreased` : '',
        increasedDetails ? `${increasedDetails} Increased` : ''
      ].filter(Boolean).join(', ');

      const res = await profileModel.post("/getVikritiFromAIWithParam", {
        UID: selectedPatientdetails.UID,
        patient_details: selectedPatientdetails,
        chief_complaints: symptoms,
        ayurvedic_assessment: Ayurvedaparameters.reduce((acc, p) => ({ ...acc, [p.parameter]: p.value }), {}),
        vital_signs: combinedMetrics,
        prakriti_dosha: patientProfile?.Prakriti_details?.result || {},
        past_history: diseases || [],
        current_drugs: currentDrugs || [],
        ai_reports: aiParameters || [],
        vikriti_dosha: vikriti,
      })

      if (res.status === 200) {
        let cleanData = res?.data?.analysis
        const parsedData = JSON.parse(cleanData);

        // Map backend response to frontend v, p, k
        // Handle both formats: {v, p, k, reason} and {increased_dosha, decreased_dosha}
        let v = 0, p = 0, k = 0;
        let reason = "";

        if (parsedData.v !== undefined && parsedData.p !== undefined && parsedData.k !== undefined) {
          // Direct v, p, k format: {"v":1,"p":1,"k":0,"reason":"..."}
          v = parsedData.v;
          p = parsedData.p;
          k = parsedData.k;
          reason = parsedData.reason || "";
        } else {
          // Legacy format: {increased_dosha: {dosha, reason}, decreased_dosha: {dosha, reason}}
          if (parsedData.increased_dosha?.dosha === "vata") v = 1;
          if (parsedData.increased_dosha?.dosha === "pitta") p = 1;
          if (parsedData.increased_dosha?.dosha === "kapha") k = 1;
          if (parsedData.decreased_dosha?.dosha === "vata") v = -1;
          if (parsedData.decreased_dosha?.dosha === "pitta") p = -1;
          if (parsedData.decreased_dosha?.dosha === "kapha") k = -1;
          reason = `Increased: ${parsedData.increased_dosha?.reason || ""}. Decreased: ${parsedData.decreased_dosha?.reason || ""}.`;
        }

        const result = getDoshamStatus(v, p, k);

        setDosham({
          ...result,
          Reason: reason
        })

        setdoshaAIdiagnois(parsedData);
        console.log(parsedData);
      }
    } catch (err) {
      console.log("Error fetching AI response:", err);
      setError(err.message || "An error occurred while fetching the AI response.");
    } finally {
      setDoshaLoading(false);
    }
  };

  const handleHerbSuggestion = async () => {
    try {
      setLoading(true);
      setError(null);

      const details = [
        patientProfile?.Prakriti_details?.result
          ? `Prakriti: ${JSON.stringify(patientProfile.Prakriti_details.result, null, 2)}`
          : 'Prakriti: ""',

        patientProfile?.Vikriti_details?.Result
          ? `Vikriti: ${JSON.stringify(patientProfile.Vikriti_details.Result)}`
          : 'Vikriti: ""',

        Array.isArray(symptoms) && symptoms.length
          ? `Symptoms: ${symptoms.map((e) => e?.symptoms).join(", ")}`
          : 'Symptoms: ""',

        selectedPatientdetails?.gender
          ? `Gender: ${selectedPatientdetails.gender}`
          : 'Gender: ""',

        selectedPatientdetails?.height
          ? `Height: ${selectedPatientdetails.height}`
          : 'Height: ""',

        selectedPatientdetails?.weight
          ? `Weight: ${selectedPatientdetails.weight}`
          : 'Weight: ""',
      ].join("\n");


      const querySuggestion = `
      Given the following Ayurvedic assessment details of a person, suggest 3-5 herbal medicines that can help balance the doshas and alleviate the symptoms.
    
      Input Details:
      ${details}
    
      Task:
      Based on Ayurvedic principles, analyze the input and recommend only those herbal medicines that are present in the provided database. Each recommendation must include a short explanation (2-3 sentences) describing the herb's benefits and how it supports dosha balance.
    
      Herbal products available (select only from this list): ${herbalProducts.map((product) => `${product.name} (ID: ${product.id})`).join(", ")}}
    
      Output Format:
      Return the result strictly as a JSON array in the exact same structure used in our database.
    `;

      const res = await reportsModel.post("/checkQuery", { query: querySuggestion });

      if (res.status === 200) {
        let cleanData = res.data.trim();

        if (cleanData.startsWith("```json")) {
          cleanData = cleanData.replace(/```json|```/g, "").trim();
        }
        const parsedData = JSON.parse(cleanData);
        setHerbSuggestions(parsedData);
        console.log(parsedData);
      } else {
        console.error("Unexpected API response:", res);
        setError("Unexpected API response.");
      }
    } catch (err) {
      console.error("Error fetching herb suggestions:", err);
      setError(err.message || "An error occurred while fetching herb suggestions.");
    } finally {
      setLoading(false);
    }
  };

  const handlelifeStyleAISuggestion = async () => {
    try {
      setlifestylechangesloading(true);
      setError(null);

      const queryLifestyleEnhancement = `
You are an Ayurvedic Doctor.

Task:
Take the following raw lifestyle recommendations input by a user and transform them into clear, grammatically correct, and contextually enhanced lifestyle suggestions aligned with Ayurvedic principles.

Strict Instructions:
- Return ONLY the transformed lifestyle suggestions.
- DO NOT return headings, labels, explanations, notes, examples, or introductory text.
- DO NOT include words like "Output:", "Here are", "Suggestions:", or any similar text.
- DO NOT combine all points into one paragraph.
- Return each suggestion as a separate line using \\n.
- Each point must be independent and self-contained.
- Correct grammar and sentence structure.
- Elaborate each point into a clear, concise instruction in 1-2 sentences.
- If the input does not contain valid lifestyle recommendation points, return an empty string.
- If the input is plain unrelated text and not lifestyle guidance, return an empty string.

Input:
${lifestylechanges}
`;

      const res = await reportsModel.post("/checkQuery", {
        query: queryLifestyleEnhancement,
      });

      if (res.status === 200) {
        let outputstring = res.data || "";

        setlifestylechanges(outputstring);
      } else {
        console.log("Unexpected API response:", res);
        setError("Unexpected API response.");
      }
    } catch (err) {
      console.log("Error fetching lifestyle suggestions:", err);
      setError(err.message || "An error occurred while fetching lifestyle suggestions.");
    } finally {
      setlifestylechangesloading(false);
    }
  };

  const Categories = [
    {
      name: "All",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/all_product_icon.png",
      type: "All",
    },
    {
      name: "Tablets",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Tablets.png",
      type: "Tablets",
    },
    {
      name: "Powders",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Powders.png",
      type: "Churna",
    },
    {
      name: "Oils",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Oils.png",
      type: "Oil",
    },
    {
      name: "Ghee",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Ghee.png",
      type: "Ghee",
    },
    {
      name: "Decoctions",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Decoctions.png",
      type: "Kashayam (Decoctions)",
    },
    {
      name: "Fermented",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Fermented.png",
      type: "Arishta",
    },
    {
      name: "Miscellaneous",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Miscellaneous.png",
      type: "Miscellaneous",
    },
    {
      name: "Syrups",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Syrups.png",
      type: "Syrup",
    },
    {
      name: "Tea",
      img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Tea.png",
      type: "Tea",
    },
  ];

  const productTypeMapping = {
    All: [],
    Tablets: ["Tablet", "Tablets"],
    Churna: ["Churna"],
    Oil: ["Oil", "Oils"],
    Ghee: ["Ghee"],
    "Kashayam (Decoctions)": ["Kashayam (Decoctions)"],
    Arishta: ["Arishta"],
    Miscellaneous: ["Miscellaneous", "Misc", "Lehyam"],
    Syrup: ["Syrup"],
    Tea: ["Tea", "Ayurvedic Tea"],
  };

  const menstrualData = [
    { key: "menarcheAge", label: "Menarche (Age at First Period)", input: "Numeric" },
    { key: "lastMenstrualPeriod", label: "Last Menstrual Period (LMP)", input: "Date" },
    { key: "cycleRegularity", label: "Cycle Regularity", input: "dropdown", values: "Regular, Irregular, Unsure" },
    { key: "cycleLength", label: "Cycle Length", input: "String" },
    { key: "durationOfBleeding", label: "Duration of Bleeding", input: "String" },
    { key: "bleedingPattern", label: "Bleeding Pattern", input: "dropdown", values: "Light, Moderate, Heavy, Spotting, Postmenopausal bleeding" },
    { key: "dysmenorrhea", label: "Presence of Dysmenorrhea (Painful Periods)", input: "Categorical", values: "Yes, No, Sometimes" },
    { key: "premenstrualSymptoms", label: "Presence of Premenstrual Symptoms", input: "Categorical", values: "Yes, No" },
    { key: "hormonalTherapy", label: "Use of hormonal contraceptives or therapy", input: "Categorical", values: "Yes, No", conditional: true },
    { key: "postmenopausal", label: "Are you postmenopausal (if applicable)", input: "Categorical", values: "Yes, No", conditional: true }
  ];

  const [showModal, setShowModal] = useState(false);

  const handleChange = (label, value) => {
    setFormData(prev => ({ ...prev, [label]: value }));
  };

  const handleConditionalInput = (label, conditionValue, extraFieldValue) => {
    setFormData(prev => ({
      ...prev,
      [label]: conditionValue === 'Yes'
        ? { answer: conditionValue, details: extraFieldValue }
        : conditionValue
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(false);
  };

  const handleProductCategorySelect = (categoryType) => {
    setSelectedProductCategory(categoryType);
  };

  const handleFrequencyChange = (index, value) => {
    setSymptoms((prev) => {
      const updated = [...prev];
      updated[index].frequency = value;
      return updated;
    });
  };

  const handleGoalToggle = (index, checked) => {
    setSymptoms((prev) => {
      const updated = [...prev];
      updated[index].goal = checked;
      return updated;
    });
  };

  const handleDurationChange = (index, value) => {
    setSymptoms((prev) => {
      const updated = [...prev];
      updated[index].duration = value;
      return updated;
    });
  };

  const handleDiseaseDurationChange = (index, value) => {
    setDiseases((prev) => {
      const updated = [...prev];
      updated[index].duration = value;
      return updated;
    });
  };

  const handleDiseaseSeverityChange = (index, value) => {
    setDiseases((prev) => {
      const updated = [...prev];
      updated[index].severity = value;
      return updated;
    });
  };

  const handleAddDisease = () => {
    setDiseases((prev) => [...prev, { disease: "", duration: "", severity: 0 }]);
  };

  const handleDeleteDisease = (index) => {
    setDiseases((prev) => prev.filter((_, i) => i !== index));
  };

  const mapQuestionIdToParameter = (questionId) => {
    switch (questionId) {

      case '10001':
        return 'Agni';

      case '10018':
        return 'Malam';

      case '10021':
        return 'Mutram';

      case '10026':
        return 'Vyayamam';

      case '10017':
        return 'Koshtam'

      case '10073':
        return 'Nidra';

      default:
        return null;
    }
  };

  const mapAnswerToValue = (answer, id) => {

    switch (id) {
      case "10001":
        if (answer.includes("Less frequent, once in 5-6 hours & mostly not hungry on time")) return "Poor";
        if (answer.includes("Normal or average appetite, once in 4-5 hours")) return "Normal";
        if (answer.includes("Frequent, once in every 2-3 hours")) return "Excess";
        return "NA";
      case "10018":
        if (answer.includes("Hard & difficult to pass stool")) return "Hard";
        if (answer.includes("Loose or semi-solid & easy to pass")) return "Loose";
        if (answer.includes("Well formed stools")) return "Normal";
        return "NA";
      case "10021":
        if (answer.includes("Infrequent (Approximately every 5-6 hours)")) return "Scanty";
        if (answer.includes("Medium (Approximately every 3-4 hours)")) return "Normal";
        if (answer.includes("Frequent (Approximately every 2 hours)")) return "Excess";
        return "NA";

      case "10073":
        if (answer.includes("Low (4-6 hours)")) return "Decreased";
        if (answer.includes("Medium (6-8 hours)")) return "Normal";
        if (answer.includes("High (more than 8 hours)")) return "Excess";
        return "NA";

      case "10017":
        if (answer.includes("Not regular and also time varies")) return "krura";
        if (answer.includes("Occasionally irregular otherwise routine")) return "Madhya";
        if (answer.includes("Daily & consistent with timings")) return "Murdu";
        return "NA";

      default:
        return "NA";
    }
  };

  const ayurvedaFields = {
    Agni: {
      icon: AgniIcon,
      options: ["Mandagni", "Vishamagni", "Samagni", "Tikshnagni"]
    },
    Manas: {
      icon: MansaIcon,
      options: ["Pravara", "Madhyama", "Avara"]
    },
    Nidra: {
      icon: NidraIcon,
      options: ["Normal", "Alpa", "Atinidra"]
    },
    Koshtam: {
      icon: KosthamIcon,
      options: ["Mrdu", "Madhyama", "Krura"]
    },
    Malam: {
      icon: MalamIcon,
      options: ["Ama-avastha", "Nirama-avastha"]
    },
    Mutram: {
      icon: MutramIcon,
      options: ["Vata", "Pitta", "Kapha"]
    },
    Vyayamam: {
      icon: VyayamamIcon,
      options: ["Uttama", "Madhyama", "Alpa"]
    },
    Vyadhiavastha: {
      icon: VyadhiavasthaIcon,
      options: ["Asukari", "Chirakari"]
    }
  };

  const bloodSugarTypes = ["Fasting", "Postprandial", "Random"];

  const metricList = [
    {
      label: "Blood Pressure",
      key: "bloodPressure",
      unit: "mmHg",
    },

    {
      label: "Blood Sugar",
      key: "randomBloodSugar",
      unit: "mg/dl",
      typeSelector: bloodSugarTypes,
      typeKey: "bloodSugarType",
    },

    {
      label: "Pulse Rate",
      key: "pulseRate",
      unit: "bpm",
    },

    {
      label: "Oximeter Value",
      key: "oximeterValue",
      unit: "%",
    },

    // {
    //   label: "Grip Strength",
    //   key: "gripStrength",
    //   unit: "kg",
    // },

  ];

  const handleConfirm = () => {
    setacknowledge(true);
    setTimeout(() => {
      handlesubmitPrescription(true);
    }, 300);
  };

  const handleCancel = () => {
    setShowExitModal(false);
    if (!hasPushed.current) {
      window.history.pushState(null, document.title);
      hasPushed.current = true;
    }
  };

  const handleDiscard = () => {
    setShowExitModal(false);
    clearReportsStore();
    resetPrescriptionState();
    setShouldNavigate(true);
    setTimeout(() => {
      navigate("/", { replace: true });
    }, 300);
  };

  const getDietRecommendations = (prakriti, vikriti) => {
    return new Promise(async (resolve, reject) => {
      try {
        const DietRecommendations = AllrawDiet;

        // Normalize search criteria: combine prakriti (string) and vikriti (array)
        const criteria = new Set();
        if (prakriti) {
          prakriti.toLowerCase().split('').forEach(char => {
            if (['v', 'p', 'k'].includes(char)) criteria.add(char);
          });
          // Also add the full prakriti initial string if it's like 'vp'
          criteria.add(prakriti.toLowerCase());
        }

        vikriti.forEach(v => {
          const initial = v.toLowerCase().charAt(0);
          if (['v', 'p', 'k'].includes(initial)) criteria.add(initial);
        });

        const criteriaList = Array.from(criteria);

        const NotRecommended = DietRecommendations?.filter((e) => {
          const foodNotToBeTakenFor = e?.foodNotToBeTakenFor?.split(',')?.map(item => item?.trim()?.toLowerCase()) || [];

          let isNotSuitable = foodNotToBeTakenFor.some((item) => {
            // Check for direct match with initials or reversed (e.g., 'pv' vs 'vp')
            const isMatch = criteriaList.some(c =>
              c === item ||
              c?.split('')?.reverse()?.join('') === item
            );

            if (isMatch) return true;

            // Handle VPK/General cases
            if (criteriaList.includes('vpk') && item === 'g') return true;

            return false;
          });

          return isNotSuitable;
        }).filter((obj, index, self) => index === self?.findIndex((o) => o?.englishName === obj?.englishName));

        const Recommended = DietRecommendations.filter((e) => {
          const foodToBeTakenFor = e?.foodToBeTakenFor?.split(',')?.map(item => item?.trim()?.toLowerCase()) || [];

          let isSuitable = foodToBeTakenFor.some((item) => {
            const isMatch = criteriaList.some(c =>
              c === item ||
              c?.split('')?.reverse()?.join('') === item
            );

            if (isMatch) return true;

            if ((criteriaList.includes('vpk') || criteriaList.some(c => c.length >= 3)) && item === 'g') {
              return true;

            }

            return false;
          });

          return isSuitable;
        }).filter((obj, index, self) => index === self?.findIndex((o) => o?.englishName === obj?.englishName));

        const filterByReference = (arr1, arr2) => {
          return arr1.filter(el => {
            return !arr2.some(element => element?.englishName === el.englishName);
          });
        };

        const Suitable = filterByReference(Recommended, NotRecommended);
        const NotSuitable = NotRecommended;

        resolve({ Suitable, NotSuitable });

      } catch (error) {
        reject(new Error(`Error fetching diet recommendations: ${error.message}`));
      }
    });
  };

  const handleDietSuggestions = async () => {
    try {
      setDietLoading(true);
      const prakritiRaw = Prakriti_details?.result || findVPKResult([
        Prakriti_details?.vata,
        Prakriti_details?.pitta,
        Prakriti_details?.kapha,
      ]);

      console.log("Prakriti details", Prakriti_details)

      const vikritiRaw = Dosham?.Increased?.doshas || [];

      if (!prakritiRaw && vikritiRaw.length === 0) {
        toast.error("No Prakriti or Vikriti dosha is found", {
          position: "top-center",
          limit: 1,
          transition: Zoom,
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        return;
      }

      // Map to initials
      const mapToInitial = (name) => {
        if (!name) return "";
        const lower = name.toLowerCase();
        if (lower.includes('vata') && lower.includes('pitta') && lower.includes('kapha')) return "vpk";
        if (lower.includes('vata') && lower.includes('pitta')) return "vp";
        if (lower.includes('vata') && lower.includes('kapha')) return "vk";
        if (lower.includes('pitta') && lower.includes('kapha')) return "pk";
        if (lower.includes('vata')) return "v";
        if (lower.includes('pitta')) return "p";
        if (lower.includes('kapha')) return "k";
        return lower; // fallback
      };

      const prakritiInitials = mapToInitial(prakritiRaw);
      const vikritiInitials = vikritiRaw.map(d => mapToInitial(d)).filter(Boolean);

      console.log("Prakriti Initials:", prakritiInitials);
      console.log("Vikriti Initials:", vikritiInitials);

      const data = await getDietRecommendations(prakritiInitials, vikritiInitials);

      const { Suitable, NotSuitable } = data;

      for (const item of Suitable) {
        const isChecked = FoodtobeTaken.some(
          (i) => i.id === item.id
        );
        handleCheckboxChange(item, !isChecked, 'included');
      }

      for (const item of NotSuitable) {
        const isChecked = Foodtobeavoided.some(
          (i) => i.id === item.id
        );
        handleCheckboxChange(item, !isChecked, 'avoided');
      }

    }
    catch (error) {
      console.log(`Error fetching diet recommendations: ${error.message}`);
    } finally {
      setDietLoading(false);
    }
  };

  const headerCellStyle = {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    color: "#3B362A",
    fontSize: "16px",
    padding: "10px",
  };

  const inputStyle = {
    "& .MuiFilledInput-root": {
      "&:before": { borderBottom: "2px solid rgba(0, 0, 0, 0.2)" },
      "&:after": { borderBottom: "2px solid #da6e0b" },
    },
    "& label.Mui-focused": {
      color: "#da6e0b",
    },
  };

  const handleFamilyFieldChange = (index, field, value) => {
    setFamilyHistory((prev) => {
      const updated = [...(Array.isArray(prev) ? prev : [])];
      if (updated[index]) {
        updated[index] = { ...updated[index], [field]: value };
      }
      return updated;
    });
  };

  const handleCurrentDrugsFieldChange = (index, field, value) => {
    setcurrentDrugs((prev) => {
      const updated = [...(Array.isArray(prev) ? prev : [])];
      if (updated[index]) {
        updated[index] = { ...updated[index], [field]: value };
      }
      return updated;
    });
  };
  const handleAddFamily = () => {
    setFamilyHistory((prev) => [
      ...(Array.isArray(prev) ? prev : []),
      { relation: '', disease: '', duration: '' },
    ]);
  };

  const handleDeleteFamily = (index) => {
    setFamilyHistory((prev) => {
      const updated = [...(Array.isArray(prev) ? prev : [])];
      updated.splice(index, 1);
      return updated;
    });
  };

  const handleToggle = (type, item) => {
    const listMap = {
      yoga: yogalist,
      pranayama: pranayama,
      meditation: meditationList,
    };

    const setMap = {
      yoga: setyogalist,
      pranayama: setPranayamaList,
      meditation: setMeditationlist,
    };
    const listRaw = listMap[type];
    const setList = setMap[type];

    const list = Array.isArray(listRaw) ? listRaw : [];
    const itemId = String(type === "meditation" ? item.Id : item.id);
    const exists = list.find(i => String(type === "meditation" ? i.Id : i.id) === itemId);

    if (exists) {
      setList(list.filter(i => String(type === "meditation" ? i.Id : i.id) !== itemId));
    } else {
      setList([...list, { ...item }]);
    }
  };

  const handleFieldChange = (type, itemId, field, value) => {

    const listMap = {
      yoga: yogalist,
      pranayama: pranayama,
      meditation: meditationList,
    };

    const setMap = {
      yoga: setyogalist,
      pranayama: setPranayamaList,
      meditation: setMeditationlist,
    };

    const list = listMap[type];
    const setList = setMap[type];

    const updated = list.map(item => {
      const currentId = type === "meditation" ? item.Id : item.id;
      if (currentId === itemId) {
        return { ...item, [field]: value };
      }
      return item;
    });

    setList(updated);
  };

  const renderTable = (type, data, fieldLabel) => {
    const rawList = { yoga: yogalist, pranayama: pranayama, meditation: meditationList }[type];
    const list = Array.isArray(rawList) ? rawList : [];
    const selectedIds = list.map(i => String(type === "meditation" ? i.Id : i.id));

    const selectedData = data.filter(item => {
      const itemId = String(type === "meditation" ? item.Id : item.id);
      return selectedIds.includes(itemId);
    });

    return (
      <table className="practice-table">
        <thead>
          <tr>
            <th>Select</th>
            <th>Practice</th>
            <th>{fieldLabel}</th>
          </tr>
        </thead>
        <tbody>
          {selectedData.map(item => {
            const itemId = String(type === "meditation" ? item.Id : item.id);
            const selectedItem = list.find(i => String(type === "meditation" ? i.Id : i.id) === itemId);

            return (
              <tr key={itemId}>
                <td>
                  <Checkbox
                    checked={true}
                    onChange={() => handleToggle(type, item)}
                  />
                </td>
                <td>{item.title || item.pose}</td>
                <td>
                  <TextField
                    size="small"
                    type="number"
                    value={selectedItem?.[fieldLabel.toLowerCase()] || ""}
                    onChange={(e) =>
                      handleFieldChange(type, itemId, fieldLabel.toLowerCase(), e.target.value)
                    }
                    style={{ width: 100 }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const [drawerOpen, setDrawerOpen] = useState(false);

  const [activeType, setActiveType] = useState(null);

  const handleDrawerOpen = (type) => {
    setActiveType(type);
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setActiveType(null);
  };

  const renderItems = (type, displayList, selectedListRaw, inputField) => {
    const selectedList = Array.isArray(selectedListRaw) ? selectedListRaw : Object.values(selectedListRaw || {});
    const selectedIds = selectedList.map(p => (type === "meditation" ? p.Id : p.id));

    return (
      <div className="flex flex-wrap items-stretch gap-2 mt-2">
        {displayList.map(item => {
          const itemId = item.Id || item.id;
          const isSelected = selectedIds.includes(itemId);
          const selectedItem = selectedList.find(p => (p.Id || p.id) === itemId) || {};

          return (
            <Tooltip
              key={itemId}
              title={<span><strong>Reason:</strong> {item.reason}<br /><strong>Dosha:</strong> {item.doshaTargeted}</span>}
              arrow
            >
              <div className="food-item relative">
                <div className="food-item-img-container mb-2" onClick={() => handleToggle(type, item)}>
                  <img src={item.image} alt={item.title} className="food-image" />
                  <input type="checkbox" checked={isSelected} readOnly className="overlay-checkbox" />
                </div>
                <p className="mt-2 w-full" style={{ width: "10rem" }}>{item.title || item.pose}</p>
                {isSelected && (
                  <TextField
                    size="small"
                    type="number"
                    value={selectedItem?.[inputField] || ""}
                    label={inputField === "duration" ? "Minutes" : "Reps"}
                    onChange={(e) => handleFieldChange(type, itemId, inputField, e.target.value)}
                    style={{ width: "90px", marginTop: "6px" }}
                  />
                )}
              </div>
            </Tooltip>
          );
        })}
      </div>
    );
  };

  const MEAL_ORDER = ["breakfast", "mid-day-snack", "lunch", "snack", "dinner"];

  const MEAL_LABELS = {
    "breakfast": "Breakfast",
    "mid-day-snack": "Mid-day snack",
    "lunch": "Lunch",
    "snack": "Snack",
    "dinner": "Dinner",
  };

  const normalizeMeal = (val = "") => {
    const s = String(val).toLowerCase().replace(/_/g, "-").replace(/\s+/g, "-");
    if (MEAL_ORDER.includes(s)) return s;
    if (/mid/.test(s) && /snack/.test(s)) return "mid-day-snack";
    if (/break/.test(s)) return "breakfast";
    if (/lunch/.test(s)) return "lunch";
    if (/dinner/.test(s)) return "dinner";
    if (/snack/.test(s)) return "snack";
    return "snack";
  };

  const grouped = React.useMemo(() => {
    const acc = Object.fromEntries(MEAL_ORDER.map(k => [k, []]));
    (selectedRecipes || []).forEach(e => {
      const key = normalizeMeal(e.time ?? e.mealType ?? e.slot);
      acc[key].push(e);
    });
    return acc;
  }, [selectedRecipes]);


  return (
    <div style={{ backgroundColor: "#fdfdfd" }}>
      <nav
        className="flex items-center p-2 mt-2 ml-2 mr-2 border rounded-lg cursor-pointer"
        style={{ backgroundColor: "#f4ecd6" }}
      >
        <IconButton
          onClick={() => {
            navigate(-1);
          }}
        >
          <ChevronLeft />
        </IconButton>

        <p className="ml-2 text-lg font-medium">Prescription</p>
      </nav>

      {/* Progress and Timer Header */}
      <Box sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        borderBottom: '1px solid #e0e0e0',
        px: 3,
        py: 1.5,
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
      }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography variant="body2" fontWeight="600" color="#666" sx={{ minWidth: '120px' }}>
                Completion: {prescriptionProgress}%
              </Typography>
              <Box sx={{ flexGrow: 1 }}>
                <LinearProgress
                  variant="determinate"
                  value={prescriptionProgress}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: '#eee',
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: prescriptionProgress === 100 ? '#4caf50' : '#DA6E0B',
                      borderRadius: 4,
                    }
                  }}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" justifyContent="flex-end" alignItems="center" gap={3}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body2" color="#666">Time Consumed:</Typography>
                <Typography variant="body1" fontWeight="700" color="#DA6E0B" sx={{ minWidth: '60px' }}>
                  {formatTime(elapsedTime)}
                </Typography>
              </Box>
              <Box sx={{ height: '24px', width: '1px', backgroundColor: '#e0e0e0' }} />
              <Typography variant="body2" color="#999">
                Started at: {new Date(creationStartTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <ConfirmExitModal show={showExitModal} onConfirm={handleConfirm} onCancel={handleCancel} onDiscard={handleDiscard} loading={loading} />

      <div className="UploadPrescription-page" >

        <div className="Prescription-sections">

          <div className="flex flex-row justify-between items-center w-full">
            <div className="datectn">{new Date().toDateString()}</div>
            <div>
              <AudioRecorder
                onTranscriptChange={setTranscript}
                onOriginalTranscriptChange={setOriginalTranscript}
              />
            </div>

            {isTranscriptSet === true && (
              <div className="audio-transcript-container">
                {audioBase64 && (
                  <AudioPlayer
                    src={audioBase64}
                    onPlay={() => console.log("onPlay")}
                  />
                )}

                <p>{originalTranscript}</p>

                <textarea
                  className="transcript-textarea mt-3"
                  value={transcript}
                  onChange={(e) => setTranscript(e.target.value)}
                  rows="4"
                />
              </div>
            )}

          </div>

          <p className="Prescription-sh-h">Patient Details</p>

          <div className="Patient-Details flex flex-row items-center w-full flex-wrap gap-5">
            <div className="flex flex-row gap-2 items-center">
              <p>Name:</p>
              <input
                type="text"
                value={`${selectedPatientdetails.firstname || ""} ${selectedPatientdetails.lastname || ""
                  }`}
                onChange={(e) => {
                  const [first, last] = e.target.value.split(" ");
                  setSelectedPatientdetails((prev) => ({
                    ...prev,
                    firstname: first || "",
                    lastname: last || "",
                  }));
                }}
                className="border p-1 w-50 rounded-lg"
              />
            </div>

            <div className="flex flex-row gap-2 items-center">
              <p>Gender:</p>
              <select
                value={selectedPatientdetails.gender}
                onChange={(e) => handlePatientDetailChanges(e, "gender")}
                className="border w-35 p-1 px-2 rounded-md"
              >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="flex flex-row gap-2 items-center">
              <p>Age:</p>
              <input
                type="number"
                value={selectedPatientdetails.dob}
                onChange={(e) => handlePatientDetailChanges(e, "dob")}
                className="border p-1 w-20 rounded-md"
              />
            </div>

            {/* HEIGHT */}
            <div className="flex gap-2 items-center">
              <p>Height:</p>
              <select
                value={selectedPatientdetails.height_unit}
                onChange={(e) => handlePatientDetailChanges(e, "height_unit")}
                className="border p-1 rounded"
              >
                <option value="cm">cm</option>
                <option value="ft">feet + inches</option>
              </select>

              {selectedPatientdetails.height_unit === "ft" ? (
                <>
                  <input
                    type="number"
                    placeholder="feet"
                    value={selectedPatientdetails.height_ft || ""}
                    onChange={(e) =>
                      handlePatientDetailChanges(e, "height_ft")
                    }
                    className="border p-1 w-20 rounded-md"
                  />
                  <input
                    type="number"
                    placeholder="inches"
                    value={selectedPatientdetails.height_in || ""}
                    onChange={(e) =>
                      handlePatientDetailChanges(e, "height_in")
                    }
                    className="border p-1 w-20 rounded-md"
                  />
                </>
              ) : (
                <input
                  type="number"
                  placeholder="cm"
                  value={selectedPatientdetails.height_cm || ""}
                  onChange={(e) => handlePatientDetailChanges(e, "height_cm")}
                  className="border p-1 w-24 rounded-md"
                />
              )}
            </div>

            {/* WEIGHT */}
            <div className="flex gap-2 items-center">
              <p>Weight:</p>
              <select
                value={selectedPatientdetails.weight_unit}
                onChange={(e) => handlePatientDetailChanges(e, "weight_unit")}
                className="border p-1 rounded"
              >
                <option value="kg">kg</option>
                <option value="lbs">lbs</option>
              </select>

              {selectedPatientdetails.weight_unit === "lbs" ? (
                <input
                  type="number"
                  placeholder="lbs"
                  value={selectedPatientdetails.weight_lbs || ""}
                  onChange={(e) => handlePatientDetailChanges(e, "weight_lbs")}
                  className="border p-1 w-24 rounded-md"
                />
              ) : (
                <input
                  type="number"
                  placeholder="kg"
                  value={selectedPatientdetails.weight_kg || ""}
                  onChange={(e) => handlePatientDetailChanges(e, "weight_kg")}
                  className="border p-1 w-24 rounded-md"
                />
              )}
            </div>

            {/* BMI */}
            <div className="flex gap-2 items-center">
              <p>BMI:</p>
              <input
                type="number"
                value={selectedPatientdetails.bmi || ""}
                readOnly
                className="border p-1 w-24 rounded-md bg-gray-100 text-gray-700"
              />
            </div>
          </div>

          <div>
            <p className="Prescription-sh-h">Chief Complaints</p>
            <div>
              <TableContainer component={Paper}>
                <Table aria-label="symptoms table">
                  <TableHead style={{ backgroundColor: "#D4CEC3" }}>

                    <TableRow>
                      <TableCell
                        sx={{ width: "20%" }}
                        align="center"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: 500,
                          color: "#3B362A",
                          fontSize: "16px",
                          padding: "10px",
                        }}
                      >
                        Symptom
                      </TableCell>

                      <TableCell
                        sx={{ width: "20%" }}
                        align="center"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: 500,
                          color: "#3B362A",
                          fontSize: "16px",
                          padding: "10px",
                        }}
                      >
                        Severity
                      </TableCell>
                      <TableCell
                        sx={{ width: "15%" }}
                        align="center"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: 500,
                          color: "#3B362A",
                          fontSize: "16px",
                          padding: "10px",
                        }}
                      >
                        Duration
                      </TableCell>
                      <TableCell
                        sx={{ width: "15%" }}
                        align="center"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: 500,
                          color: "#3B362A",
                          fontSize: "16px",
                          padding: "10px",
                        }}
                      >
                        Frequency
                      </TableCell>
                      <TableCell
                        sx={{ width: "10%" }}
                        align="center"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: 500,
                          color: "#3B362A",
                          fontSize: "16px",
                          padding: "10px",
                        }}
                      >Goal Setting</TableCell>
                      <TableCell
                        sx={{ width: "10%" }}
                        align="center"
                      ></TableCell>
                    </TableRow>

                  </TableHead>

                  <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                    {symptoms?.map((e, i) => (
                      <TableRow key={i}>
                        {/* Symptom Name */}
                        <TableCell sx={{ width: "20%" }}>
                          <TextField
                            value={e.symptoms}
                            onChange={(event) => handleSymptomChange(i, event.target.value)}
                            label="Symptom"
                            variant="filled"
                            size="small"
                            sx={{

                              "& .MuiFilledInput-root": {

                                "&:before": {
                                  borderBottom: "2px solid rgba(0, 0, 0, 0.2)", // unfocused
                                },
                                "&:after": {
                                  borderBottom: "2px solid #da6e0b", // focused
                                },
                              },
                              "& label.Mui-focused": {
                                color: "#da6e0b",
                              },
                            }}

                          />
                        </TableCell>

                        <TableCell sx={{ width: "50%" }}>
                          <Box sx={{ maxWidth: "340px", mx: "auto" }}>
                            <Slider
                              step={1}
                              value={e?.severity}
                              max={5}
                              marks={[
                                { value: 0, label: '0' },
                                { value: 1, label: '1' },
                                { value: 2, label: '2' },
                                { value: 3, label: '3' },
                                { value: 4, label: '4' },
                                { value: 5, label: '5' }
                              ]}
                              valueLabelDisplay="auto"

                              onChange={(event, newValue) => handleSeverityChange(i, newValue)}
                              sx={{
                                "& .MuiSlider-thumb": { color: "#8CEB8C" },
                                "& .MuiSlider-track": { color: "#8CEB8C" },
                                "& .MuiSlider-rail": { color: "#acc4e4" },
                                "& .MuiSlider-valueLabel": {
                                  backgroundColor: "#75623F",
                                  color: "#fff",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  padding: "8px",
                                  top: -6,
                                  "& *": {
                                    background: "transparent",
                                    color: "#fff",
                                  },
                                },
                              }}
                              valueLabelFormat={(value) => {
                                const labelMap = {
                                  0: { text: "Good", icon: "None.png" },
                                  1: { text: "Mild", icon: "Low.png" },
                                  2: { text: "Moderate", icon: "Moderate.png" },
                                  3: { text: "High", icon: "High.png" },
                                  4: { text: "Severe", icon: "Severe.png" },
                                  5: { text: "Extreme", icon: "Extreme.png" },
                                };

                                const { text, icon } = labelMap[value] || {};

                                return (
                                  <div style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "column" }}>
                                    {/* <img
                                      src={`/images/${icon}`}
                                      alt={text}
                                      width="20"
                                      height="20"
                                      style={{ borderRadius: "50%" }}
                                    /> */}
                                    <span>{text}</span>
                                  </div>
                                );
                              }}


                            />
                          </Box>
                        </TableCell>


                        <TableCell sx={{ width: "15%" }}>
                          <TextField
                            value={e.duration || ""}
                            onChange={(event) => handleDurationChange(i, event.target.value)}
                            label="Duration"
                            variant="filled"
                            size="small"
                            sx={{

                              "& .MuiFilledInput-root": {

                                "&:before": {
                                  borderBottom: "2px solid rgba(0, 0, 0, 0.2)", // unfocused
                                },
                                "&:after": {
                                  borderBottom: "2px solid #da6e0b", // focused
                                },
                              },
                              "& label.Mui-focused": {
                                color: "#da6e0b",
                              },
                            }}
                          />
                        </TableCell>

                        {/* Frequency */}
                        <TableCell sx={{ width: "15%" }}>
                          <TextField
                            value={e?.frequency || ""}
                            onChange={(event) => handleFrequencyChange(i, event.target.value)}
                            label="Frequency"
                            variant="filled"
                            size="small"
                            sx={{

                              "& .MuiFilledInput-root": {

                                "&:before": {
                                  borderBottom: "2px solid rgba(0, 0, 0, 0.2)", // unfocused
                                },
                                "&:after": {
                                  borderBottom: "2px solid #da6e0b", // focused
                                },
                              },
                              "& label.Mui-focused": {
                                color: "#da6e0b",
                              },
                            }}
                          />
                        </TableCell>

                        {/* Goal Checkbox */}
                        <TableCell sx={{ width: "10%" }} align="center">
                          <Checkbox
                            checked={!!e.goal}
                            onChange={(event) => handleGoalToggle(i, event.target.checked)}
                            color="primary"
                          />
                        </TableCell>

                        {/* Delete */}
                        <TableCell sx={{ width: "10%" }} align="center">
                          <IconButton
                            onClick={() => handleDeleteRow(i)}
                            color="error"
                            size="small"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>

                  {(!symptoms || symptoms.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={4} align="center" sx={{ py: 3, color: "text.secondary" }}>
                        No symptoms added yet.
                      </TableCell>
                    </TableRow>
                  )}

                </Table>
              </TableContainer>

              <div className="mt-5 flex justify-end">
                <Button
                  onClick={handleAddRow}
                  variant="contained"
                  style={{
                    textTransform: "none",
                    borderRadius: "5px",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                  }}
                  endIcon={<AddIcon />}
                >
                  Add Complaint
                </Button>
              </div>

            </div>

          </div>

          <div>

            <div className="flex flex-row justify-between items-center">
              <p className="Prescription-sh-h">Past History</p>
            </div>

            <div className="Diseases-container">
              <TableContainer component={Paper}>
                <Table>
                  <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                    <TableRow>
                      <TableCell align="center" style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        color: "#3B362A",
                        fontSize: "16px",
                        padding: "10px",
                      }}>Disease</TableCell>
                      <TableCell align="center" style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        color: "#3B362A",
                        fontSize: "16px",
                        padding: "10px",
                      }}>Severity</TableCell>
                      <TableCell align="center" style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        color: "#3B362A",
                        fontSize: "16px",
                        padding: "10px",
                      }}>Duration</TableCell>

                      <TableCell />
                    </TableRow>
                  </TableHead>
                  {(!diseases || diseases.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={4} align="center" sx={{ py: 3, color: "text.secondary" }}>
                        No diseases added yet.
                      </TableCell>
                    </TableRow>
                  )}
                  <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                    {diseases.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <TextField
                            value={item.ayurvedaDisease}
                            variant="filled"
                            onChange={(e) => handleDiseaseFieldChange(index, 'ayurvedaDisease', e.target.value)}
                            label="Ayurveda Disease Name"
                            size="small"
                            sx={{
                              mb: 1,
                              mr: 1,
                              "& .MuiFilledInput-root": {
                                "&:before": { borderBottom: "2px solid rgba(0, 0, 0, 0.2)" },
                                "&:after": { borderBottom: "2px solid #da6e0b" },
                              },
                              "& label.Mui-focused": { color: "#da6e0b" },
                            }}
                          />
                          <TextField
                            value={item.modernDisease}
                            variant="filled"
                            onChange={(e) => handleDiseaseFieldChange(index, 'modernDisease', e.target.value)}
                            label="Modern Disease Name"
                            size="small"
                            sx={{
                              "& .MuiFilledInput-root": {
                                "&:before": { borderBottom: "2px solid rgba(0, 0, 0, 0.2)" },
                                "&:after": { borderBottom: "2px solid #da6e0b" },
                              },
                              "& label.Mui-focused": { color: "#da6e0b" },
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ width: "340px", mx: "auto" }}>
                            <Slider
                              value={item.severity}
                              onChange={(e, val) => handleDiseaseSeverityChange(index, val)}
                              step={1}
                              marks={[
                                { value: 0, label: '0' },
                                { value: 1, label: '1' },
                                { value: 2, label: '2' },
                                { value: 3, label: '3' },
                                { value: 4, label: '4' },
                                { value: 5, label: '5' }
                              ]}
                              max={5}
                              valueLabelDisplay="auto"
                              sx={{
                                "& .MuiSlider-thumb": { color: "#8CEB8C" },
                                "& .MuiSlider-track": { color: "#8CEB8C" },
                                "& .MuiSlider-rail": { color: "#acc4e4" },
                                "& .MuiSlider-valueLabel": {
                                  backgroundColor: "#75623F",
                                  color: "#fff",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  padding: "8px",
                                  top: -6,
                                  "& *": {
                                    background: "transparent",
                                    color: "#fff",
                                  },
                                },
                              }}

                              valueLabelFormat={(value) => {
                                const labelMap = {
                                  0: { text: "Good", icon: "None.png" },
                                  1: { text: "Mild", icon: "Low.png" },
                                  2: { text: "Moderate", icon: "Moderate.png" },
                                  3: { text: "High", icon: "High.png" },
                                  4: { text: "Severe", icon: "Severe.png" },
                                  5: { text: "Extreme", icon: "Extreme.png" },
                                };

                                const { text, icon } = labelMap[value] || {};

                                return (
                                  <div style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "column" }}>
                                    {/* <img
                                      src={`/images/${icon}`}
                                      alt={text}
                                      width="20"
                                      height="20"
                                      style={{ borderRadius: "50%" }}
                                    /> */}
                                    <span>{text}</span>
                                  </div>
                                );
                              }}
                            />
                          </Box>
                        </TableCell>

                        <TableCell>
                          <TextField
                            value={item.duration}
                            onChange={(e) => handleDiseaseDurationChange(index, e.target.value)}
                            label="Duration"
                            variant="filled"
                            size="small"
                            sx={{

                              "& .MuiFilledInput-root": {

                                "&:before": {
                                  borderBottom: "2px solid rgba(0, 0, 0, 0.2)", // unfocused
                                },
                                "&:after": {
                                  borderBottom: "2px solid #da6e0b", // focused
                                },
                              },
                              "& label.Mui-focused": {
                                color: "#da6e0b",
                              },
                            }}
                          />

                        </TableCell>

                        <TableCell align="center">
                          <IconButton onClick={() => handleDeleteDisease(index)} color="error">
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="mt-5 flex justify-end">
                <Button
                  onClick={handleAddDisease}
                  variant="contained"
                  style={{
                    textTransform: "none",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    borderRadius: "5px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                  }}
                  endIcon={<AddIcon />}
                >
                  Add Disease
                </Button>
              </div>
            </div>

            <div className="flex flex-row justify-between items-center">
              <p className="Prescription-sh-h">Complications</p>
            </div>

            <div className="Complications-container">
              <TableContainer component={Paper}>
                <Table>
                  <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                    <TableRow>
                      <TableCell align="center" style={headerCellStyle}>Complication</TableCell>
                      <TableCell align="center" style={headerCellStyle}>Severity</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                    {(complications || []).map((item, index) => {
                      const compValue = typeof item === 'string' ? item : item?.complication || "";
                      const severityValue = typeof item === 'string' ? 0 : item?.severity || 0;
                      return (
                      <TableRow key={index}>
                        <TableCell align="center" sx={{ width: "30%" }}>
                          <TextField
                            value={compValue}
                            onChange={(e) => handleComplicationChange(index, e.target.value)}
                            label="Complication"
                            variant="filled"
                            size="small"
                            sx={inputStyle}
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ width: "240px", mx: "auto" }}>
                            <Slider
                              value={severityValue}
                              onChange={(e, val) => handleComplicationSeverityChange(index, val)}
                              step={1}
                              marks={[
                                { value: 0, label: '0' },
                                { value: 1, label: '1' },
                                { value: 2, label: '2' },
                                { value: 3, label: '3' },
                                { value: 4, label: '4' },
                                { value: 5, label: '5' }
                              ]}
                              max={5}
                              valueLabelDisplay="auto"
                              sx={{
                                "& .MuiSlider-thumb": { color: "#8CEB8C" },
                                "& .MuiSlider-track": { color: "#8CEB8C" },
                                "& .MuiSlider-rail": { color: "#acc4e4" },
                                "& .MuiSlider-valueLabel": {
                                  backgroundColor: "#75623F",
                                  color: "#fff",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  padding: "8px",
                                }
                              }}
                            />
                          </Box>
                        </TableCell>
                        <TableCell align="center">
                          <IconButton onClick={() => handleDeleteComplication(index)} color="error">
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )})}
                  </TableBody>
                </Table>
              </TableContainer>

              <div className="mt-5 flex justify-end">
                <Button
                  onClick={handleAddComplication}
                  variant="contained"
                  style={{
                    textTransform: "none",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    borderRadius: "5px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                  }}
                  endIcon={<AddIcon />}
                >
                  Add Complication
                </Button>
              </div>
            </div>

            <div className="flex flex-row justify-between items-center">
              <p className="Prescription-sh-h">Habits</p>
            </div>

            <div className="Habits-container">
              <TableContainer component={Paper}>
                <Table>
                  <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                    <TableRow>
                      <TableCell align="center" style={headerCellStyle}>Habit</TableCell>
                      <TableCell align="center" style={headerCellStyle}>Duration</TableCell>
                      <TableCell align="center" style={headerCellStyle}>Severity</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                    {(habits || []).map((item, index) => {
                      const habitValue = typeof item === 'string' ? item : item?.habit || "";
                      const severityValue = typeof item === 'string' ? 0 : item?.severity || 0;
                      const durationValue = typeof item === 'string' ? "" : item?.duration || "";
                      return (
                      <TableRow key={index}>
                        <TableCell align="center" sx={{ width: "30%" }}>
                          <TextField
                            value={habitValue}
                            onChange={(e) => handleHabitChange(index, e.target.value)}
                            label="Habit"
                            variant="filled"
                            size="small"
                            sx={inputStyle}
                          />
                        </TableCell>
                        <TableCell align="center" sx={{ width: "20%" }}>
                          <TextField
                            value={durationValue}
                            onChange={(e) => handleHabitDurationChange(index, e.target.value)}
                            label="Duration"
                            variant="filled"
                            size="small"
                            sx={inputStyle}
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ width: "240px", mx: "auto" }}>
                            <Slider
                              value={severityValue}
                              onChange={(e, val) => handleHabitSeverityChange(index, val)}
                              step={1}
                              marks={[
                                { value: 0, label: '0' },
                                { value: 1, label: '1' },
                                { value: 2, label: '2' },
                                { value: 3, label: '3' },
                                { value: 4, label: '4' },
                                { value: 5, label: '5' }
                              ]}
                              max={5}
                              valueLabelDisplay="auto"
                              sx={{
                                "& .MuiSlider-thumb": { color: "#8CEB8C" },
                                "& .MuiSlider-track": { color: "#8CEB8C" },
                                "& .MuiSlider-rail": { color: "#acc4e4" },
                                "& .MuiSlider-valueLabel": {
                                  backgroundColor: "#75623F",
                                  color: "#fff",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  padding: "8px",
                                }
                              }}
                            />
                          </Box>
                        </TableCell>
                        <TableCell align="center">
                          <IconButton onClick={() => handleDeleteHabit(index)} color="error">
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )})}
                  </TableBody>
                </Table>
              </TableContainer>

              <div className="mt-5 flex justify-end">
                <Button
                  onClick={handleAddHabit}
                  variant="contained"
                  style={{
                    textTransform: "none",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    borderRadius: "5px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                  }}
                  endIcon={<AddIcon />}
                >
                  Add Habit
                </Button>
              </div>
            </div>

            <div className="flex flex-row justify-between items-center">
              <p className="Prescription-sh-h">Family History</p>
            </div>

            <div className="FamilyHistory-container">
              <TableContainer component={Paper}>
                <Table>
                  <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                    <TableRow>
                      <TableCell align="center" style={headerCellStyle}>Relation</TableCell>
                      <TableCell align="center" style={headerCellStyle}>Disease</TableCell>
                      <TableCell align="center" style={headerCellStyle}>Duration</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                    {familyHistory?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          <TextField
                            value={item.relation}
                            onChange={(e) => handleFamilyFieldChange(index, 'relation', e.target.value)}
                            label="Relation"
                            variant="filled"
                            size="small"
                            sx={inputStyle}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            value={item.disease}
                            onChange={(e) => handleFamilyFieldChange(index, 'disease', e.target.value)}
                            label="Disease"
                            variant="filled"
                            size="small"
                            sx={inputStyle}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            value={item.duration}
                            onChange={(e) => handleFamilyFieldChange(index, 'duration', e.target.value)}
                            label="Duration"
                            variant="filled"
                            size="small"
                            sx={inputStyle}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton onClick={() => handleDeleteFamily(index)} color="error">
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div className="mt-5 flex justify-end">
                <Button
                  onClick={handleAddFamily}
                  variant="contained"
                  style={{
                    textTransform: "none",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    borderRadius: "5px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                  }}
                  endIcon={<AddIcon />}
                >
                  Add Family History
                </Button>
              </div>
            </div>



          </div>

          <div>
            <p className="Prescription-sh-h mb5">Current Drugs</p>
            <div>
              <Table>
                <TableHead sx={{ backgroundColor: "#D4CEC3" }}>
                  <TableRow>
                    <TableCell sx={headerCellStyle} align="center">Medicine</TableCell>
                    <TableCell sx={headerCellStyle} align="center">Dose</TableCell>
                    <TableCell sx={headerCellStyle} align="center">Duration</TableCell>
                    <TableCell sx={headerCellStyle} align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(Array.isArray(currentDrugs) ? currentDrugs : []).map((drug, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        <TextField
                          variant="filled"
                          size="small"
                          label="Medicine"
                          value={drug?.medicine ?? ""}
                          onChange={(e) => handleCurrentDrugsFieldChange(index, "medicine", e.target.value)}
                          sx={inputStyle}
                          inputProps={{ style: { textAlign: "center" }, "aria-label": "medicine" }}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <TextField
                          variant="filled"
                          size="small"
                          label="Dose"
                          value={drug?.dose ?? ""}
                          onChange={(e) => handleCurrentDrugsFieldChange(index, "dose", e.target.value)}
                          sx={inputStyle}
                          inputProps={{ style: { textAlign: "center" }, "aria-label": "dose" }}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <TextField
                          variant="filled"
                          size="small"
                          label="Duration"
                          value={drug?.duration ?? ""}
                          onChange={(e) => handleCurrentDrugsFieldChange(index, "duration", e.target.value)}
                          sx={inputStyle}
                          inputProps={{ style: { textAlign: "center" }, "aria-label": "duration" }}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <IconButton onClick={() => removeCurrentdrugs(index)} color="error" aria-label="remove medicine">
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}

                  {(!currentDrugs || currentDrugs.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={4} align="center" sx={{ py: 3, color: "text.secondary" }}>
                        No medicines added yet.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>

              </Table>

              <div className="mt-5 flex justify-end">
                <Button
                  onClick={addCurrentdrugs}
                  variant="contained"
                  style={{
                    textTransform: "none",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    borderRadius: "5px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                  }}
                  endIcon={<AddIcon />}
                >
                  Add Current Drugs
                </Button>
              </div>
            </div>
          </div>

          {selectedPatientdetails?.gender?.toLowerCase()?.includes('female') && (
            <div className="mt-10">
              <div className="flex flex-row justify-between items-center">
                <p className="Prescription-sh-h">Menstruation / Obstetrical</p>
                <button
                  onClick={() => setShowModal(true)}
                  variant="contained"
                  style={{
                    textTransform: "none",
                    borderRadius: "0",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    border: "none",
                    boxSizing: "border-box",
                    borderRadius: "5px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                    width: "300px",
                    height: "40px"
                  }}
                >
                  Open Menstrual History Form
                </button>

              </div>

              <div>
                <p>

                </p>
              </div>

              <div>

              </div>

            </div>
          )}

          <div className='flex flex-row justify-between'>
            <div className='w-full max-w-md'>
              <div>
                <p className='rec-rem-T' >Prakriti Dosha</p>

              </div>

              <div className="p-4 w-full text-center bg-[#EFEFE7] mt-2">

                <div className="space-y-4">
                  {[
                    { name: "Vata", color: "#FF9800", key: "vata" },
                    { name: "Pitta", color: "#795548", key: "pitta" },
                    { name: "Kapha", color: "#8DE995", key: "kapha" },
                  ].map(({ name, color, key }) => {
                    const value =
                      Prakriti_details && typeof Prakriti_details[key] === "number"
                        ? Prakriti_details[key]
                        : "";

                    return (
                      <div
                        key={key}
                        className="flex justify-between items-center"
                        style={{ gap: "12px" }}
                      >
                        <div className="flex items-center" style={{ gap: "8px" }}>
                          <span className="text-[#3B362A] font-semibold">{name}</span>
                        </div>

                        <input
                          type="number"
                          min={0}
                          max={100}
                          value={Math.ceil(value)}
                          onChange={(e) => {
                            const newValue = parseInt(e.target.value.trim(), 10) || 0;
                            const othersSum = ["vata", "pitta", "kapha"]
                              .filter((k) => k !== key)
                              .reduce((sum, otherKey) => {
                                const otherVal =
                                  Prakriti_details && typeof Prakriti_details[otherKey] === "number"
                                    ? Prakriti_details[otherKey]
                                    : 0;
                                return sum + otherVal;
                              }, 0);

                            if (newValue + othersSum <= 100) {
                              setPrakritiDetails((prev) => ({
                                ...prev,
                                [key]: newValue,
                              }));
                            } else {
                              toast.error("The sum of Prakriti values cannot exceed 100", {
                                position: "top-center",
                                autoClose: 2000,
                                theme: "dark",
                              });
                            }
                          }}
                          className="w-24 px-3 py-2 text-center border border-gray-300 rounded bg-[#F4F4EE] text-[#3B362A]"
                          onKeyPress={handleKeyPress}
                        />
                      </div>
                    );
                  })}
                  <p style={{ fontSize: '10px', color: '#666', marginTop: '-5px', marginBottom: '5px' }}>All three dosha values should sum to 100</p>
                </div>

                <div className="mt-4 pt-3 border-t border-[#D9D9D2]">
                  <p style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#666",
                    marginBottom: "4px"
                  }}>Prakriti Result</p>
                  <p style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 700,
                    fontSize: "18px",
                    color: "#DA6E0B",
                    letterSpacing: "0.5px"
                  }}>
                    {
                      Prakriti_details
                        ? findVPKResult([
                          Prakriti_details.vata,
                          Prakriti_details.pitta,
                          Prakriti_details.kapha,
                        ])
                        : "Not available"
                    }
                  </p>
                </div>
              </div>

            </div>

          </div>

          <div>

            <div>
              <p className="Prescription-sh-h">Ayurveda Clinical Assessment</p>
            </div>

            <div className="mt-10 bg-gray-50 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {Ayurvedaparameters?.map((param) => {
                  const field = ayurvedaFields[param.parameter];
                  return (
                    <div
                      key={param.parameter}
                      className="flex items-center justify-between p-3 bg-white rounded border"
                    >
                      <div className="flex items-center gap-2 min-w-[200px] ayurveda-field-label">
                        {field?.icon && <img src={field.icon} alt={param.parameter} className="w-10 h-10 object-contain" />}
                        <p>{param.parameter.replace(/([A-Z])/g, ' $1').trim()}</p>
                      </div>


                      <div className="flex items-center gap-2" >
                        <span
                          className={`px-3 py-1 rounded text-sm font-medium cursor-pointer ${param.value
                            ? 'bg-green-100 text-green-800'
                            : 'bg-gray-100 text-gray-500'
                            }`}
                          onClick={() => setDialogParamKey(param.parameter)}
                        >
                          {param.value || 'Asses Now'}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

          </div>

          <div>

            <div>

              <p className="Prescription-sh-h">Vital Signs</p>
              <div className="p-2">

                <div className="flex flex-row items-center w-full flex-wrap gap-4">
                  {metricList.map((metric) => (
                    <div key={metric.key} className="min-w-[220px] flex-grow">
                      <TextField
                        fullWidth
                        label={metric.label}
                        value={metrics[metric.key] || ""}
                        onChange={(e) =>
                          handleMetricChange(metric.key, e.target.value)
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {metric.typeSelector ? (
                                <Select
                                  value={metrics[metric.typeKey] || ""}
                                  onChange={(e) => handleMetricChange(metric.typeKey, e.target.value)}
                                  displayEmpty
                                  sx={{
                                    backgroundColor: "#F1EFEC",
                                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                                    fontSize: "0.875rem",
                                    height: "2rem",
                                    mr: 1,
                                  }}
                                >
                                  <MenuItem value="" disabled>
                                    <em>Select Option</em>
                                  </MenuItem>
                                  {metric.typeSelector.map((type) => (
                                    <MenuItem key={type} value={type}>
                                      {type}
                                    </MenuItem>
                                  ))}
                                </Select>
                              ) : null}
                              {metric.unit}
                            </InputAdornment>

                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#F1EFEC",
                            "&.Mui-focused fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiInputBase-root": {
                            "&:focus": {
                              outline: "none",
                            },
                          },
                          "& .MuiInputAdornment-root": {
                            backgroundColor: "#F1EFEC",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                          },
                        }}
                      />
                    </div>
                  ))}
                </div>

              </div>
            </div>

            {showModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                <div className="bg-white p-6 rounded-lg max-w-2xl w-full overflow-y-auto max-h-[90vh] relative">
                  <h2 className="text-xl font-bold mb-4">Menstrual History Form</h2>

                  <form onSubmit={handleSubmit} className="space-y-4">
                    {menstrualData.map((item, index) => {
                      const key = item.key;
                      const label = item.label.trim();
                      const value = formData[key] || '';

                      if (item.input === 'Numeric') {
                        return (
                          <div key={index}>
                            <label>{label}:</label>
                            <input
                              type="number"
                              value={value}
                              onChange={(e) => handleChange(key, e.target.value)}
                              className="border px-2 py-1 rounded w-full"
                            />
                          </div>
                        );
                      }

                      if (item.input === 'String') {
                        return (
                          <div key={index}>
                            <label>{label}:</label>
                            <input
                              type="text"
                              value={value}
                              onChange={(e) => handleChange(key, e.target.value)}
                              className="border px-2 py-1 rounded w-full"
                            />
                          </div>
                        );
                      }

                      if (item.input === 'Date') {
                        return (
                          <div key={index}>
                            <label>{label}:</label>
                            <input
                              type="date"
                              value={value}
                              onChange={(e) => handleChange(key, e.target.value)}
                              className="border px-2 py-1 rounded w-full"
                            />
                          </div>
                        );
                      }

                      if (item.input === 'dropdown' || item.input === 'Categorical') {
                        const options = item.values.split(',').map(v => v.trim());
                        const conditional = item.conditional;

                        return (
                          <div key={index}>
                            <label>{label}:</label>
                            <select
                              value={typeof value === 'object' ? value.answer : value}
                              onChange={(e) => {
                                if (conditional) {
                                  handleConditionalInput(key, e.target.value, '');
                                } else {
                                  handleChange(key, e.target.value);
                                }
                              }}
                              className="border px-2 py-1 rounded w-full"
                            >
                              <option value="">Select</option>
                              {options.map((opt, idx) => (
                                <option key={idx} value={opt}>{opt}</option>
                              ))}
                            </select>

                            {conditional && (value.answer === 'Yes' || value === 'Yes') && (
                              <input
                                type="text"
                                placeholder="Provide details"
                                value={value.details || ''}
                                onChange={(e) => handleConditionalInput(key, 'Yes', e.target.value)}
                                className="mt-2 border px-2 py-1 rounded w-full"
                              />
                            )}
                          </div>
                        );
                      }

                      return null;
                    })}

                    <div className="flex justify-end space-x-2">
                      <button
                        type="button"
                        onClick={() => setShowModal(false)}
                        className="bg-gray-400 text-white px-4 py-2 rounded"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="bg-[#DA6E0B] text-white px-4 py-2 rounded"
                      >
                        Submit
                      </button>
                    </div>
                  </form>

                </div>
              </div>
            )}

            <div>
              <div className="mt-4">

                <p className="Prescription-sh-h">Additional Metrics</p>

                {customMetrics?.map((customMetric, index) => (
                  <Grid
                    container
                    spacing={1}
                    key={index}
                    alignItems="center"
                    sx={{ marginBottom: 0.5, marginTop: 0.5 }}
                  >
                    <Grid item xs={5.5}>
                      <TextField
                        fullWidth
                        label="Key"
                        value={customMetric.key}
                        className="medicine-input5"
                        id="outlined-basic"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiInputBase-root": {
                            "&:focus": {
                              outline: "none",
                            },
                          },
                        }}
                        onChange={(e) =>
                          handleCustomMetricChange(index, "key", e.target.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={5.5}>
                      <TextField
                        fullWidth
                        label="Value"
                        value={customMetric.value}
                        className="medicine-input5"
                        id="outlined-basic"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiInputBase-root": {
                            "&:focus": {
                              outline: "none",
                            },
                          },
                        }}
                        onChange={(e) =>
                          handleCustomMetricChange(index, "value", e.target.value)
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteCustomMetric(index)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}

              </div>

              <div className="mt-5 flex justify-end">
                <Button
                  onClick={handleAddCustomMetric}
                  variant="contained"
                  style={{
                    textTransform: "none",
                    borderRadius: "0",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    border: "none",
                    boxSizing: "border-box",
                    borderRadius: "5px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    padding: "10px",
                  }}
                  endIcon={<AddIcon />}
                >
                  Add Metric
                </Button>
              </div>

              <div>
                <div style={{ marginTop: "20px" }}>
                  <p className="Prescription-sh-h ">Suggested Lab Tests</p>
                  <div className="mt-2">
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={14}>
                        <Autocomplete
                          multiple
                          freeSolo
                          options={suggestions}
                          value={labTests}
                          onChange={(event, newValues) => setLabTests(newValues)}
                          onInputChange={(event, newValue) =>
                            setNewTest(newValue)
                          }
                          renderTags={() => null} // Hides selected items from appearing inside the input
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Enter or Select Lab Tests"
                              placeholder="Type to search..."
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>

                      {/* <Grid item xs={1}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddTest}
                        // disabled={!newTest}
                        style={{
                          textTransform: "none",
                          borderRadius: "0",
                          backgroundColor: "#DA6E0B",
                          color: "white",
                          border: "none",
                          boxSizing: "border-box",
                          borderRadius: "5px",
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: 500,
                          padding: "10px",
                        }}
                      >
                        Add
                      </Button>
                    </Grid> */}

                    </Grid>
                  </div>
                  <div className="FoodContainer mt-2">
                    {labTests.map((e, i) => {
                      return (
                        <div className="FoodCard">
                          <p>{e}</p>
                          <IconButton onClick={() => handleRemoveTest(i)}>
                            <DeleteIcon sx={{ fontSize: "16px" }} />
                          </IconButton>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

            </div>

            {
              aiParameters && aiParameters.length > 0 &&
              <div className="mt-5">
                <p className="Prescription-sh-h">AI Reports</p>

                <div>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                        <TableRow>
                          <TableCell style={headerCellStyle} align="center">Name</TableCell>
                          <TableCell style={headerCellStyle} align="center">Value</TableCell>
                          <TableCell style={headerCellStyle} align="center">Status</TableCell>
                          <TableCell style={headerCellStyle} align="center">Reference Range</TableCell>
                          <TableCell style={headerCellStyle} align="center">Note</TableCell>
                          <TableCell style={headerCellStyle} align="center">Severity</TableCell>
                          <TableCell style={headerCellStyle} align="center">Goal</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                        {aiParameters.map((param, index) => (
                          <TableRow key={index}>


                            <TableCell>
                              <TextField
                                value={param.name}
                                onChange={(e) =>
                                  handleAIparametersChange(index, 'name', e.target.value)
                                }
                                fullWidth
                                variant="filled"
                                size="small"
                              />
                            </TableCell>


                            <TableCell>
                              <TextField
                                value={param.value}
                                onChange={(e) =>
                                  handleAIparametersChange(index, 'value', e.target.value)
                                }
                                fullWidth
                                variant="filled"
                                size="small"
                              />
                            </TableCell>


                            <TableCell>
                              <FormControl size="small" fullWidth>
                                <Select
                                  value={param.status || ""}
                                  onChange={(e) => handleAIparametersChange(index, "status", e.target.value)}
                                >
                                  <MenuItem value="normal">Normal</MenuItem>
                                  <MenuItem value="low">Low</MenuItem>
                                  <MenuItem value="high">High</MenuItem>
                                  <MenuItem value="borderline">Borderline</MenuItem>
                                  <MenuItem value="critical">Critical</MenuItem>
                                </Select>
                              </FormControl>
                            </TableCell>

                            {/* Reference Range - Editable Text */}
                            <TableCell>
                              <TextField
                                value={param.reference_range}
                                onChange={(e) =>
                                  handleAIparametersChange(index, 'reference_range', e.target.value)
                                }
                                fullWidth
                                variant="filled"
                                size="small"
                              />
                            </TableCell>

                            {/* Reason - Editable Text */}
                            <TableCell>
                              <TextField
                                value={param.reason}
                                onChange={(e) =>
                                  handleAIparametersChange(index, 'reason', e.target.value)
                                }
                                fullWidth
                                variant="filled"
                                size="small"
                              />
                            </TableCell>

                            {/* Severity - Editable Text */}
                            <TableCell>
                              <Box sx={{ width: "240px", mx: "auto" }}>
                                <Slider
                                  value={param.severity}
                                  onChange={(e, val) => handleAIparametersChange(index, 'severity', val)}
                                  step={1}
                                  marks={[
                                    { value: 0, label: '0' },
                                    { value: 1, label: '1' },
                                    { value: 2, label: '2' },
                                    { value: 3, label: '3' },
                                    { value: 4, label: '4' },
                                    { value: 5, label: '5' }
                                  ]}
                                  max={5}
                                  valueLabelDisplay="auto"
                                  sx={{
                                    "& .MuiSlider-thumb": { color: "#8CEB8C" },
                                    "& .MuiSlider-track": { color: "#8CEB8C" },
                                    "& .MuiSlider-rail": { color: "#acc4e4" },
                                    "& .MuiSlider-valueLabel": {
                                      backgroundColor: "#75623F",
                                      color: "#fff",
                                      borderRadius: "6px",
                                      fontSize: "12px",
                                      padding: "8px",
                                      top: -6,
                                      "& *": {
                                        background: "transparent",
                                        color: "#fff",
                                      },
                                    },
                                  }}

                                  valueLabelFormat={(value) => {
                                    const labelMap = {
                                      0: { text: "Good", icon: "None.png" },
                                      1: { text: "Mild", icon: "Low.png" },
                                      2: { text: "Moderate", icon: "Moderate.png" },
                                      3: { text: "High", icon: "High.png" },
                                      4: { text: "Severe", icon: "Severe.png" },
                                      5: { text: "Extreme", icon: "Extreme.png" },
                                    };

                                    const { text, icon } = labelMap[value] || {};

                                    return (
                                      <div style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "column" }}>
                                        {/* <img
                                      src={`/images/${icon}`}
                                      alt={text}
                                      width="20"
                                      height="20"
                                      style={{ borderRadius: "50%" }}
                                    /> */}
                                        <span>{text}</span>
                                      </div>
                                    );
                                  }}
                                />
                              </Box>
                            </TableCell>

                            {/* Goal - Checkbox */}
                            <TableCell align="center">
                              <Checkbox
                                checked={param.goal}
                                onChange={(e) =>
                                  handleGoalToggle2(index, e.target.checked)
                                }
                                color="primary"
                              />
                            </TableCell>

                            <TableCell align="center">
                              <IconButton
                                onClick={() => handleDeleteParam(index)}
                                color="error"
                                size="small"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </TableCell>

                          </TableRow>
                        ))}
                      </TableBody>

                    </Table>
                  </TableContainer>
                </div>

              </div>

            }



            <div className="mt-5">

              <div className="flex gap-5 justify-between item-center">
                <p className='rec-rem-T'>Vikriti Dosha</p>
                <div>
                  <Button style={{
                    textTransform: "none",
                    borderRadius: "5px",
                    backgroundColor: "#DA6E0B",
                    color: "white",
                    border: "none",
                    boxSizing: "border-box",
                    padding: "10px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                  }}
                    disabled={doshaLoading}
                    onClick={handleAyurvedaDoshaDiagnosisAISuggestion}>
                    {doshaLoading ? <CircularProgress size={20} color="inherit" /> : "AI Dosha Prediction"}
                  </Button>
                </div>
              </div>

              <div className='flex flex-row gap-5 mt-5'>
                {['Increased', 'Decreased'].map((type) => (
                  <div key={type} className="bg-[#EFEFE7] rounded-lg shadow-md p-5 mb-6">
                    <h4 className="text-md font-semibold text-[#3B362A] mb-4">{type}</h4>
                    <div className="flex flex-col gap-3">
                      {['vata', 'pitta', 'kapha'].map((dosha) => (
                        <div
                          key={dosha}
                          className="flex flex-row items-center gap-4 w-full"
                        >

                          <div className="w-1/4 flex items-center space-x-2">
                            <input
                              type="checkbox"
                              value={dosha}
                              checked={Dosham[type].doshas.includes(dosha)}
                              onChange={(e) => HandleDosham(type, dosha, e.target.checked)}
                              disabled={Dosham[type === 'Increased' ? 'Decreased' : 'Increased'].doshas.includes(dosha)}
                              className="accent-[#DA6E0B] w-4 h-4"
                            />
                            <span className="text-[#3B362A] font-medium capitalize">{dosha}</span>
                          </div>


                          <div className="w-1/4">
                            <input
                              type="number"
                              placeholder="Percentage"
                              min={0}
                              max={100}
                              className="w-full bg-white border border-gray-300 rounded px-3 py-2 text-sm text-[#3B362A]"
                              value={Dosham[type].percentage[dosha] || ''}
                              onChange={(e) => updateDoshaPercentage(type, dosha, e.target.value)}
                            />
                          </div>


                          <div className="w-1/2">
                            <select
                              className="w-full bg-white border border-gray-300 rounded px-3 py-2 text-sm text-[#3B362A]"
                              value={Dosham[type].intensity[dosha] || ''}
                              onChange={(e) => updateDoshaIntensity(type, dosha, e.target.value)}
                            >
                              <option value="">Select Intensity</option>
                              <option value="Mild">Mild</option>
                              <option value="Moderate">Moderate</option>
                              <option value="Severe">Severe</option>
                            </select>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                ))}

                  <div className="bg-[#EFEFE7] rounded-lg shadow-md max-w-lg w-full p-5 mb-6">

                    <p className="text-md font-semibold text-[#3B362A]" style={{
                      fontFamily: "'Poppins', sans-serif",
                    }}>
                      Reason:
                    </p>

                    <TextField
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={5}

                      value={Dosham?.Reason || ''}
                      onChange={(e) => {
                        setDosham(prev => ({
                          ...prev,
                          Reason: e.target.value
                        }));

                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": { border: "none" },
                        },
                        "& .MuiInputBase-root": {
                          "&:focus": { outline: "none" },
                        },
                      }}
                      InputProps={{

                        style: {
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: '0.875rem',
                          fontWeight: 400,
                          marginTop: '0.5rem',
                          backgroundColor: '#F9F9F4'
                        }
                      }}
                    />
                  </div>


              </div>

            </div>

            <div>

              <div className="flex flex-row justify-between items-center">

                <p className="Prescription-sh-h">Diagnosis</p>

                <Button style={{
                  textTransform: "none",
                  borderRadius: "5px",
                  backgroundColor: "#DA6E0B",
                  color: "white",
                  border: "none",
                  boxSizing: "border-box",
                  padding: "10px",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                }}
                  disabled={diagnosisLoading}
                  onClick={handleOpenDialogAi}>
                  {diagnosisLoading ? <CircularProgress size={20} color="inherit" /> : "AI Diagnosis"}
                </Button>

              </div>

              <div className="mt-2 flex gap-4">
                <TextField
                  sx={{
                    width: "100%",
                    maxWidth: "500px",
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                    },
                    "& .MuiInputBase-root": {
                      "&:focus": {
                        outline: "none",
                      },
                    },
                  }}
                  id="outlined-basic"
                  value={Medicaldetails?.ayurvedadiagnosis}
                  label="Ayurveda Diagnosis"
                  onChange={(e) => {
                    handleMedicaldetails("ayurvedadiagnosis", e.target.value);
                  }}
                  variant="outlined"
                />

                <TextField
                  sx={{
                    width: "100%",
                    maxWidth: "500px",
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                    },
                    "& .MuiInputBase-root": {
                      "&:focus": {
                        outline: "none",
                      },
                    },
                  }}
                  id="outlined-basic"
                  value={Medicaldetails?.moderndiagnosis}
                  label="Modern Diagnosis"
                  onChange={(e) => {
                    handleMedicaldetails("moderndiagnosis", e.target.value);
                  }}
                  variant="outlined"
                />
              </div>

            </div>

            <div>
              <div className="flex flex-row justify-between items-center">
                <p className="Prescription-sh-h">Herbal Medicines</p>
                <Button style={{
                  textTransform: "none",
                  borderRadius: "5px",
                  backgroundColor: "#DA6E0B",
                  color: "white",
                  border: "none",
                  boxSizing: "border-box",
                  padding: "10px",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                }}
                  disabled={MedicineRecommendationLoading}
                  onClick={async () => {
                    if (!symptoms || symptoms.length === 0) {
                      toast.error("Please enter chief complaints before proceeding", {
                        position: "top-center",
                        limit: 1,
                        transition: Zoom,
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                      });
                      return;
                    }
                    else {
                      await getMedicineRecommendations()
                      navigate('/prescription/medicines')
                    }
                  }}>
                  {MedicineRecommendationLoading ? <CircularProgress size={20} color="inherit" /> : "AI Suggestions"}
                </Button>

              </div>

              <div className="flex flex-wrap gap-5 items-center mt-3 w-full">
                {Medicineinputs?.map((input, index) => (
                  <div
                    key={index}
                    className="flex flex-wrap gap-3 items-center w-full md:w-auto"
                  >
                    <TextField
                      label="Medicine Name"
                      className="medicine-input"
                      sx={{
                        minWidth: 150,
                        flex: "1 1 300px",
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": { border: "none" },
                        },
                        "& .MuiInputBase-root": {
                          "&:focus": { outline: "none" },
                        },
                      }}

                      InputProps={{
                        readOnly: input?.id !== "",
                        endAdornment: !input.medicine ? (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              size="small"
                              onClick={() => handleOpenDialog(index)}
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ) : input?.id !== "" ? (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              size="small"
                              onClick={() => removeSelectedProduct(index)}
                            >
                              <HighlightOffIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}

                      value={input.medicine}

                      onChange={(event) =>
                        handleInputChange(index, event.target.value, "medicine")
                      }

                      variant="outlined"
                    />

                    <div className="w-full md:w-auto">
                      <FormControl
                        className="medicine-input"
                        sx={{
                          minWidth: 150,
                          flex: "1 1 230px",
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": { border: "none" },
                          },
                          "& .MuiInputBase-root": {
                            "&:focus": { outline: "none" },
                          },
                        }}
                      >
                        <InputLabel sx={{ fontSize: "1rem" }}>Timing</InputLabel>
                        <Select
                          multiple
                          sx={{ fontSize: "0.75rem", maxWidth: "100%" }}
                          value={input?.timing ? input?.timing?.split(",") : []}
                          onChange={(event) => {
                            const selectedValues = event.target.value.join(",");
                            handleInputChange(index, selectedValues, "timing");
                          }}
                          renderValue={(selected) => (
                            <div className="flex gap-2 overflow-x-auto max-w-full whitespace-nowrap">
                              {selected.map((value) => (
                                <Chip key={value} label={value} />
                              ))}
                            </div>
                          )}
                        >
                          {["morning", "afternoon", 'Mid-day', "evening", "night"].map(
                            (option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="w-full md:w-auto">
                      <FormControl
                        className="medicine-input"
                        sx={{
                          minWidth: 150,
                          flex: "1 1 230px",
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": { border: "none" },
                          },
                          "& .MuiInputBase-root": {
                            "&:focus": { outline: "none" },
                          },
                        }}
                      >
                        <InputLabel sx={{ fontSize: "1rem" }}>Take Medicine</InputLabel>

                        <Select
                          sx={{ fontSize: "0.75rem", maxWidth: "100%" }}
                          value={input?.takeFood}
                          onChange={(event) => {
                            const selectedValues = event.target.value;
                            handleInputChange(index, selectedValues, "takeFood");
                          }}
                        >
                          {["Before Food", "After Food"].map(
                            (option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            )
                          )}
                        </Select>

                      </FormControl>
                    </div>

                    {[
                      "quantity",
                      "dose",
                      "duration",
                      "instruction",
                      "productlink",
                      "Reason",
                    ].map((field) => {
                      const numericFields = new Set(['quantity']);
                      const isNumeric = numericFields.has(field);

                      return (
                        <TextField
                          key={field}
                          label={field.charAt(0).toUpperCase() + field.slice(1)}
                          className="medicine-input"
                          type={"text"}
                          inputProps={{
                            min: 0,
                            step: 1,
                            inputMode: isNumeric ? "numeric" : "text", // Mobile numeric keyboard
                            pattern: isNumeric ? "[0-9]*" : undefined, // Prevent letters
                          }}
                          sx={{
                            minWidth: isNumeric ? 60 : 100,
                            flex: isNumeric ? "0 0 80px" : "1 1 150px",
                            "& .MuiOutlinedInput-root": {
                              "&.Mui-focused fieldset": { border: "none" },
                            },
                            "& .MuiInputBase-root": {
                              "&:focus": { outline: "none" },
                            },
                          }}
                          value={input[field] ?? ""}
                          onChange={(event) => {
                            let value = event.target.value;

                            // 🛡️ HARD BLOCK non-numeric characters
                            if (isNumeric) {
                              if (value === "") {
                                handleInputChange(index, "", field);
                                return;
                              }

                              const numericValue = Number(value);
                              if (Number.isNaN(numericValue)) return;

                              handleInputChange(index, numericValue, field); // ✅ store as number
                            } else {
                              handleInputChange(index, value, field);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (isNumeric && ["e", "E", "+", "-", "."].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          variant="outlined"
                        />
                      );
                    })}


                    {Medicineinputs?.length > 1 && (
                      <IconButton onClick={() => handleRemoveField(index)}>
                        <HighlightOffIcon style={{ cursor: "pointer" }} />
                      </IconButton>
                    )}

                  </div>

                ))}
              </div>

              {/* Total Price Summary */}
              {Medicineinputs.some(m => m.id && m.price) && (
                <Box
                  sx={{
                    mt: 3,
                    p: 1.5,
                    maxWidth: 350,
                    marginLeft: 'auto',
                    background: 'linear-gradient(135deg, #fff8f0 0%, #ffe8d6 100%)',
                    borderRadius: 2,
                    border: '2px solid #DA6E0B',
                    boxShadow: '0 4px 12px rgba(218, 110, 11, 0.1)'
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 600,
                      color: '#DA6E0B',
                      mb: 1.5,
                      fontSize: 13
                    }}
                  >
                    Price Summary
                  </Typography>

                  {Medicineinputs.filter(m => m.id && m.price).map((medicine, idx) => {
                    const quantity = Number(medicine.quantity) || 1;
                    const price = Number(medicine.price) || 0;
                    const itemTotal = quantity * price;

                    return (
                      <Box
                        key={idx}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mb: 0.5,
                          pb: 0.5,
                          borderBottom: '1px dashed #DA6E0B33'
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: 11,
                            color: '#666'
                          }}
                        >
                          {medicine.medicine} (₹{price} × {quantity})
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            fontSize: 11,
                            color: '#DA6E0B'
                          }}
                        >
                          ₹{itemTotal.toFixed(2)}
                        </Typography>
                      </Box>
                    );
                  })}

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mt: 1,
                      pt: 1,
                      borderTop: '2px solid #DA6E0B'
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 700,
                        color: '#DA6E0B',
                        fontSize: 13
                      }}
                    >
                      Total
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 700,
                        color: '#DA6E0B',
                        fontSize: 16
                      }}
                    >
                      ₹{Medicineinputs.filter(m => m.id && m.price)
                        .reduce((total, m) => {
                          const quantity = Number(m.quantity) || 1;
                          const price = Number(m.price) || 0;
                          return total + (quantity * price);
                        }, 0)
                        .toFixed(2)}
                    </Typography>
                  </Box>
                </Box>
              )}

            </div>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "500px",
                width: "100%",
              }}
            >
              <Dialog
                open={openAiHerbal}
                onClose={handleCloseHerbalAi}
                fullWidth
                maxWidth="sm"
              >
                <DialogTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  AI Suggestion For Herbal Medicines

                  <IconButton onClick={handleCloseHerbalAi} sx={{ color: "gray" }}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent>
                  <div>
                    {loading ? (
                      <Typography variant="body1">Loading analysis...</Typography>
                    ) : error ? (
                      <Typography variant="body1" color="error">
                        {error}
                      </Typography>
                    ) : ayurvedaAIHerbal?.length > 0 ? (
                      ayurvedaAIHerbal.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            mb: 2,
                            p: 2,
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                          }}
                        >
                          <Typography variant="h6">🩺 {item.herb}</Typography>
                          <Typography variant="body2" color="textSecondary">
                            {item.benefits}
                          </Typography>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body1">No suggestions available.</Typography>
                    )}
                  </div>
                </DialogContent>
              </Dialog>
              <Dialog
                open={openAi}
                onClose={handleCloseDialogAi}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                  sx: {
                    borderRadius: "16px",
                    padding: "8px",
                    fontFamily: "'Poppins', sans-serif"
                  }
                }}
              >
                <DialogTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pb: 1
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "#DA6E0B",
                        fontFamily: "'Poppins', sans-serif"
                      }}
                    >
                      AI Ayurveda Diagnosis
                    </Typography>
                  </Box>
                  <IconButton onClick={handleCloseDialogAi} sx={{ color: "gray" }}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent>
                  <Box sx={{ mt: 1 }}>
                    {diagnosisLoading ? (
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4, gap: 2 }}>
                        <CircularProgress sx={{ color: '#DA6E0B' }} />
                        <Typography
                          variant="body1"
                          sx={{ fontFamily: "'Poppins', sans-serif", color: '#666' }}
                        >
                          Analysing health parameters...
                        </Typography>
                      </Box>
                    ) : error ? (
                      <Typography
                        variant="body1"
                        color="error"
                        sx={{ fontFamily: "'Poppins', sans-serif", textAlign: 'center', py: 2 }}
                      >
                        {error}
                      </Typography>
                    ) : ayurvedaAIdiagnois?.length > 0 ? (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {ayurvedaAIdiagnois.map((item, index) => (
                          <Box
                            key={index}
                            sx={{
                              p: 2.5,
                              background: 'linear-gradient(135deg, #fff 0%, #fdf5ec 100%)',
                              border: "1px solid #DA6E0B33",
                              borderRadius: "12px",
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 12px rgba(218, 110, 11, 0.1)',
                                borderColor: '#DA6E0B99'
                              }
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5, gap: 1 }}>
                              <Typography
                                variant="subtitle1"
                                sx={{
                                  fontWeight: 700,
                                  color: "#DA6E0B",
                                  fontFamily: "'Poppins', sans-serif",
                                  fontSize: '1.1rem'
                                }}
                              >
                                🌿 {item.diseasename}
                              </Typography>
                            </Box>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#444",
                                lineHeight: 1.6,
                                fontFamily: "'Poppins', sans-serif",
                                fontSize: '0.9rem'
                              }}
                            >
                              {item.reason}
                            </Typography>

                            <Button
                              size="small"
                              sx={{
                                mt: 2,
                                textTransform: 'none',
                                color: '#DA6E0B',
                                fontWeight: 600,
                                fontFamily: "'Poppins', sans-serif",
                                '&:hover': { background: '#DA6E0B11' }
                              }}
                              onClick={() => {
                                handleMedicaldetails("ayurvedadiagnosis", item.diseasename);
                                handleCloseDialogAi();
                              }}
                            >
                              Apply Diagnosis
                            </Button>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Typography
                          variant="body1"
                          sx={{ fontFamily: "'Poppins', sans-serif", color: '#666' }}
                        >
                          No suggestions available. Please ensure clinical parameters are filled.
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
                  <Button
                    onClick={handleCloseDialogAi}
                    variant="outlined"
                    sx={{
                      borderRadius: '8px',
                      textTransform: 'none',
                      px: 4,
                      fontFamily: "'Poppins', sans-serif",
                      borderColor: '#DA6E0B',
                      color: '#DA6E0B',
                      '&:hover': {
                        borderColor: '#DA6E0B',
                        backgroundColor: '#DA6E0B08'
                      }
                    }}
                  >
                    Done
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>

            <div className="mt-5 flex justify-end">
              <Button
                onClick={handleAddField}
                variant="contained"
                style={{
                  textTransform: "none",
                  borderRadius: "0",
                  backgroundColor: "#DA6E0B",
                  color: "white",
                  border: "none",
                  boxSizing: "border-box",
                  borderRadius: "5px",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                  padding: "10px",
                }}
                endIcon={<AddIcon />}
              >
                Add more
              </Button>
            </div>

          </div>

          <div className="mt-2">
            <div className="flex items-center justify-between">
              <p className="Prescription-sh-h">Diet Recommendations</p>

              <Button
                onClick={() => { handleDietSuggestions() }}
                variant="contained"
                disabled={dietLoading}
                style={{
                  textTransform: "none",
                  borderRadius: "0",
                  backgroundColor: "#DA6E0B",
                  color: "white",
                  border: "none",
                  boxSizing: "border-box",
                  alignSelf: "flex-end",
                  borderRadius: "5px",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                  padding: "10px",
                }}
                endIcon={<AddIcon />}
              >
                {dietLoading ? <CircularProgress size={20} color="inherit" /> : "Diet Suggestions"}
              </Button>

            </div>



            <div className="DietRecommendation-add flex flex-row justify-between mt-2 gap-8">

              <div className="dietrc">
                <div className="DietHeader">
                  <p>Food to be included</p>
                  <div
                    className="AddButtonContainer"
                    onClick={handleOpenDialog2}
                  >
                    <IconButton onClick={handleOpenDialog2}>
                      <AddIcon />
                    </IconButton>
                  </div>

                </div>

                <Autocomplete
                  multiple
                  freeSolo
                  options={[]}
                  value={FoodtobeTaken.map(item => item.englishName)}
                  onChange={(event, newValue) => {
                    const uniqueItems = [...new Set(newValue.map(val => val.trim()).filter(val => val))];

                    const updated = uniqueItems.map(name => {
                      const existingItem = FoodtobeTaken.find(item => item.englishName === name);

                      if (existingItem) {
                        return existingItem;
                      }


                      return {
                        englishName: name,
                        categoryEng: "General",
                        categoryImg: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/General.png",
                        categoryLandingImg: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/mainicons/General.png",
                        categorySans: "NA",
                        decreasesDosha: "NA",
                        foodNotToBeTakenFor: "NA",
                        foodToBeTakenFor: "NA",
                        hindiName: "NA",
                        id: Math.random().toString(36).substr(2, 9),
                        imageLink: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png",
                        increasesDosha: "NA",
                        latinName: "NA",
                        sanskritName: "NA"
                      };
                    });

                    setFoodtobetaken(updated);
                  }}

                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option}
                        {...getTagProps({ index })}
                        sx={{
                          backgroundColor: '#EFEFE7',
                          color: '#3B362A',
                          borderRadius: '5px',
                          fontWeight: 500,
                          fontFamily: "'Poppins', sans-serif"
                        }}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Add items to include"
                      fullWidth
                      sx={{
                        backgroundColor: '#FDFDFD',
                        input: {
                          color: '#3B362A',
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: 500
                        },
                        '.MuiOutlinedInput-root': {
                          '& fieldset': { borderColor: '#ccc' },
                          '&:hover fieldset': { borderColor: '#aaa' },
                          '&.Mui-focused fieldset': { borderColor: '#75623F' }
                        }
                      }}
                    />
                  )}
                />

              </div>

              <div className="dietrc ">
                <div className="DietHeader" onClick={handleOpenDialog3}>
                  <p>Food to be Minimal</p>
                  <div className="AddButtonContainer">
                    <IconButton onClick={handleOpenDialog3}>
                      <AddIcon />
                    </IconButton>
                  </div>
                </div>
                <Autocomplete
                  multiple
                  freeSolo
                  options={[]}
                  value={Foodtobeavoided.map(item => item.englishName)}
                  onChange={(event, newValue) => {
                    const uniqueItems = [...new Set(newValue.map(val => val.trim()).filter(val => val))];

                    const updated = uniqueItems.map(name => {
                      const existingItem = Foodtobeavoided.find(item => item.englishName === name);


                      if (existingItem) {
                        return existingItem;
                      }


                      return {
                        englishName: name,
                        categoryEng: "General",
                        categoryImg: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/General.png",
                        categoryLandingImg: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/mainicons/General.png",
                        categorySans: "NA",
                        decreasesDosha: "NA",
                        foodNotToBeTakenFor: "NA",
                        foodToBeTakenFor: "NA",
                        hindiName: "NA",
                        id: Math.random().toString(36).substr(2, 9),
                        imageLink: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png",
                        increasesDosha: "NA",
                        latinName: "NA",
                        sanskritName: "NA"
                      };
                    });

                    setFoodtobeAvoided(updated);
                  }}

                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option}
                        {...getTagProps({ index })}
                        sx={{
                          backgroundColor: '#EFEFE7',
                          color: '#3B362A',
                          borderRadius: '5px',
                          fontWeight: 500,
                          fontFamily: "'Poppins', sans-serif"
                        }}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Add items to avoid"
                      fullWidth
                      sx={{
                        backgroundColor: '#FDFDFD',
                        input: {
                          color: '#3B362A',
                          fontFamily: "'Poppins', sans-serif",
                          fontWeight: 500
                        },
                        '.MuiOutlinedInput-root': {
                          '& fieldset': { borderColor: '#ccc' },
                          '&:hover fieldset': { borderColor: '#aaa' },
                          '&.Mui-focused fieldset': { borderColor: '#75623F' }
                        }
                      }}
                    />
                  )}
                />

                {/* <div className="D_dietc">
                  <div>
                    <div className="FoodtobeTaken flex flex-wrap gap-4">
                      {Foodtobeavoided.map((e) => (
                        <div
                          key={e.englishName}
                          className="FoodtobeTakencard flex flex-row items-center justify-between w-full sm:w-[48%] md:w-[30%] lg:w-[30%] p-2 border rounded-md shadow-md cursor-pointer"
                          onClick={() =>
                            handleCheckboxChange(e, false, "avoided")
                          }
                        >
                          <p className="flex-1">{e.englishName}</p>
                          <IconButton
                            onClick={() => {
                              handleCheckboxChange(e, false, "avoided");
                            }}
                          >
                            <DeleteIcon sx={{ fontSize: "20px" }} />
                          </IconButton>
                        </div>
                      ))}
                    </div>

                    
                  </div>
                </div> */}

              </div>
            </div>
          </div>

          <div>
            <div>
              <div className="flex flex-row justify-between items-center">
                <p className="Prescription-sh-h">
                  Recipes</p>
                <div className="mt-5 flex">
                  <Button
                    onClick={() => { navigate("/prescription/recipes") }}
                    variant="contained"
                    style={{
                      textTransform: "none",
                      borderRadius: "0",
                      backgroundColor: "#DA6E0B",
                      color: "white",
                      border: "none",
                      boxSizing: "border-box",
                      alignSelf: "flex-end",
                      borderRadius: "5px",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 500,
                      padding: "10px",
                    }}
                    endIcon={<AddIcon />}
                  >
                    Add Recipe
                  </Button>
                </div>
              </div>

              <div className="DietHead">

              </div>

            </div>
            <div className="dietrc">
              <div className="D_dietc">
                <div>
                  <div className="FoodtobeTaken flex flex-wrap gap-4">
                    <div className="space-y-6">
                      {MEAL_ORDER.map(key => {
                        const items = grouped[key];
                        return (
                          <section key={key} className="rounded-xl border bg-white/50 p-3 shadow-sm">
                            <div className="mb-2 flex items-baseline justify-between">
                              <h3 className="text-sm font-semibold tracking-wide">{MEAL_LABELS[key]}</h3>
                              <span className="text-xs text-gray-500">
                                {items.length} item{items.length !== 1 ? "s" : ""}
                              </span>
                            </div>

                            {items.length === 0 ? (
                              <p className="text-xs italic text-gray-400">No recipes added.</p>
                            ) : (
                              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                                {items.map(e => (
                                  <button
                                    key={e.id ?? e.recipe}
                                    type="button"
                                    className="FoodtobeTakencard group flex w-full items-center justify-between rounded-lg border p-2 shadow-sm transition hover:shadow"
                                    onClick={() => handleSelectRecipe(e, false)}
                                  >
                                    <span className="flex-1 text-left">{e.recipe}</span>
                                    <IconButton
                                      size="small"
                                      aria-label="remove recipe"
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        handleSelectRecipe(e, false);
                                      }}
                                    >
                                      <DeleteIcon sx={{ fontSize: 20 }} />
                                    </IconButton>
                                  </button>
                                ))}
                              </div>
                            )}
                          </section>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="flex flex-row justify-between items-center">
              <p className="Prescription-sh-h">Lifestyle Practices</p>
              <Button
                style={{
                  textTransform: "none",
                  borderRadius: "0",
                  backgroundColor: "#DA6E0B",
                  color: "white",
                  border: "none",
                  boxSizing: "border-box",
                  alignSelf: "flex-end",
                  borderRadius: "5px",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                  padding: "10px",
                }}

                disabled={lifestylePracticesLoading}
                onClick={async () => {
                  await getLifestylePracticesRecommendations();
                  navigate("/prescription/lifestylepractices")
                }}>
                {lifestylePracticesLoading ? <CircularProgress size={20} color="inherit" /> : "AI Suggestions"}
              </Button>
            </div>

            <div className="DietRecommendation-add" style={{ display: "flex", flexDirection: "row", gap: "32px" }}>
              <div className="practices-card">
                <div className="flex justify-between">
                  <p>Yoga</p>
                  <IconButton onClick={() => handleDrawerOpen("Yoga")}>
                    <AddIcon />
                  </IconButton>
                </div>
                {renderTable("yoga", Practices?.yoga || [], "Reps")}
              </div>

              <div className="practices-card">
                <p className="flex justify-between">
                  <b>Pranayama</b>
                  <IconButton onClick={() => handleDrawerOpen('Pranayama')}>
                    <AddIcon />
                  </IconButton></p>
                {renderTable("pranayama", Practices?.pranayama || [], "Reps")}
              </div>

              <div className="practices-card">
                <p className="flex justify-between">
                  <b>Meditation</b>
                  <IconButton onClick={() => handleDrawerOpen("Meditation")}>
                    <AddIcon />
                  </IconButton>
                </p>
                {renderTable("meditation", Practices?.meditation || [], "Duration")}
              </div>
            </div>

          </div>

        </div>

        <div>
          <div className="flex justify-between items-center">
            <p className="Prescription-sh-h mt-3 ">Lifestyle Changes</p>
            {lifestylechanges?.length > 0 && <Button
              style={{
                textTransform: "none",
                borderRadius: "0",
                backgroundColor: "#DA6E0B",
                color: "white",

                border: "none",
                boxSizing: "border-box",
                alignSelf: "flex-end",
                borderRadius: "5px",
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 500,
                padding: "10px",
              }}

              onClick={() => {
                handlelifeStyleAISuggestion();
              }
              }>

              {
                lifestylechangesloading ? <CircularProgress size={24} style={{ color: "#fdfdfd" }} /> : 'AI Re-formatting'
              }

            </Button>}
          </div>


          <div>

            <textarea
              className="w-full mt-3 lifestylechanges"
              rows="5"
              value={lifestylechanges || ''}
              style={{ resize: "none" }}
              placeholder="Enter lifestyle suggestions — use Enter to start a new line"
              onChange={(e) => setlifestylechanges(e.target.value)}
            />

            {(typeof lifestylechanges === 'string' && lifestylechanges?.split(/[\n]/)?.filter(item => item.trim().length > 0)?.length > 0) && (
              <div className="LifeStyle-changes-Container mt-4">
                <ul className="list-disc list-inside">
                  {(typeof lifestylechanges === 'string' ? lifestylechanges : '')
                    ?.split(/[\n]/)
                    ?.map(item => item.trim())
                    ?.filter(item => item.length > 0)
                    ?.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                </ul>
              </div>
            )}

          </div>

          <div>
            <p className="Prescription-sh-h">Follow up</p>
            <input
              className="ml-2"
              type="date"
              value={FollowUp}
              onChange={(e) => setfollowup(e.target.value)}
            />
            <p className="ml-2">
              Selected Date:{" "}
              {FollowUp
                ? FollowUp.split("-").reverse().join("-")
                : "No date selected"}
            </p>
          </div>

          <div>
            <div className="formbtn">
              <div className="checkbox">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setacknowledge(e?.target?.checked);
                  }}
                ></input>
                <p>
                  I, {Doctor_details?.name}, acknowledge the submission of the
                  prescription form for the patient named{" "}
                  {selectedPatientdetails?.firstname}
                  {selectedPatientdetails?.lastname ? " " + selectedPatientdetails.lastname : ""}{" "}
                  on {new Date(creationStartTime || Date.now()).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}, and confirm the review of all
                  relevant patient details and prescribed medications.
                </p>
              </div>
            </div>
          </div>

          <div style={{ width: "10rem", margin: "auto" }}>
            <div style={{ display: "flex", gap: "10px" }}>

              <Button
                style={{
                  flex: 1,
                  textTransform: "none",
                  borderRadius: "0",
                  backgroundColor: "#DA6E0B",
                  color: "white",
                  border: "none",
                  boxSizing: "border-box",
                  borderRadius: "5px",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                  padding: "10px",
                }}
                disabled={!acknowledge || loading}
                onClick={() => {
                  handlesubmitPrescription(false);
                }}
              >
                {loading ? <CircularProgress size={24} style={{ color: "#fdfdfd" }} /> : "Submit"}
              </Button>
            </div>
          </div>
        </div>

        <Dialog open={open} scroll={'paper'} onClose={handleCloseDialog}
          fullWidth={true}
          maxWidth={'lg'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"

        >

          <DialogTitle id="scroll-dialog-title">
            <div className="flex justify-between flex-row w-auto">
              <div className="flex flex-row items-center gap-2">
                <IconButton onClick={handleCloseDialog}>
                  <ArrowBackIcon />
                </IconButton>
                <div className="flex items-center justify-between gap-4">
                  <p className="Prescription-sh-h">Herbal Medicines</p>
                </div>
              </div>


              <IconButton onClick={handleCloseDialog}>
                <CloseIcon />
              </IconButton>
            </div>


          </DialogTitle>

          <DialogContent dividers tabIndex={-1} >
            <div className="Herbal-products-container w-auto h-full overflow-y-auto" >


              <Autocomplete
                multiple
                disableCloseOnSelect
                options={options}
                value={Array.isArray(Medicineinputs) ? Medicineinputs : []}
                inputValue={Search || ""}
                onInputChange={(_, value) => setsearch(value)}
                onChange={(_, newValue, reason, details) => {
                  if (reason === "clear") {
                    setMedicineinputs([{
                      medicine: "",
                      dose: "",
                      Reason: "",
                      instruction: "",
                      duration: "",
                      quantity: 1,
                      id: "",
                      timing: "",
                    }]);
                  } else if (details?.option) {
                    handleSelectMultipleProducts(details.option);
                  }
                }}
                // REMOVE this if you want normal search filtering
                // filterOptions={(x) => x}

                getOptionLabel={(option) => option?.name || option?.medicine || ""}
                isOptionEqualToValue={(option, value) =>
                  String(option?.id ?? option?._id) === String(value?.id ?? value?._id)
                }
                renderTags={() => null}
                loading={isLoading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search"
                    placeholder="Search medicine"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <li {...props} key={String(option?.id ?? option?._id)}>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <span>{option?.name || option?.medicine}</span>
                      <span style={{ opacity: 0.7 }}>(₹{option?.price ?? 0})</span>
                    </span>
                  </li>
                )}
              />

              <div className="ListofCategories">
                {Categories.map((category) => (
                  <div
                    key={category.type}
                    onClick={() => handleProductCategorySelect(category.type)}
                    className={`category-item ${selectedProductCategory.toLowerCase() === category.type.toLowerCase() ? "active-category" : ""
                      }`}
                  >
                    <img src={category.img} alt={category.name} />
                    <p className={selectedProductCategory.toLowerCase() === category.type.toLowerCase() ? "lineactive" : ""}>
                      {category.name}
                    </p>
                  </div>
                ))}
              </div>

              <div>
                {Medicineinputs.length > 0 && (
                  <div className="flex flex-wrap gap-2">
                    {Medicineinputs.filter((e) => e.id).map((product) => (
                      <Chip
                        key={product.id}
                        label={`${product.medicine} (₹${product.price})`}
                        onDelete={() => handleSelectMultipleProducts(product)}
                        sx={{
                          backgroundColor: "#DA6E0B",
                          color: "white",
                          "& .MuiChip-deleteIcon": { color: "white" },
                        }}
                        size="small"
                        className="cursor-pointer"
                      />
                    ))}
                  </div>
                )}

                <div className="herbal-products scrollbar-hide">
                  {Products.filter((product) => product.onsale).map((product) => {
                    const variants = product?.other_info?.variants || [];
                    const hasVariants = variants.length > 0;
                    const selectedVariantId = productVariants[product.id] || (hasVariants ? variants[0].id : null);
                    const selectedVariant = hasVariants ? variants.find(v => v.id === selectedVariantId) : null;
                    const displayPrice = selectedVariant ? selectedVariant.price : product.price;
                    const isSelected = Medicineinputs.some((item) => item.id === product.id);

                    return (
                      <div key={product.id} className="herbal-product-card" ref={lastPostElementRef}>
                        <div className="img-container">
                          <img
                            src={product.imgurl}
                            alt={product.name}
                            onClick={() => handleSelectMultipleProducts(product, selectedVariant)}
                          />
                        </div>
                        <p style={{ fontSize: '12px', fontWeight: 600, marginTop: '5px' }}>{product.name}</p>
                        <p style={{ color: '#DA6E0B', fontWeight: 700 }}>₹{displayPrice}</p>

                        {variants.length > 1 && (
                          <FormControl size="small" fullWidth sx={{ mt: 1 }}>
                            <Select
                              value={selectedVariantId}
                              onChange={(e) => setProductVariants(prev => ({ ...prev, [product.id]: e.target.value }))}
                              sx={{
                                fontSize: '11px',
                                height: '28px',
                                borderRadius: '8px',
                                '& .MuiSelect-select': {
                                  paddingY: '4px',
                                },
                                backgroundColor: '#f9f9f9',
                                '&:hover': {
                                  backgroundColor: '#f0f0f0'
                                }
                              }}
                            >
                              {variants.map(v => (
                                <MenuItem key={v.id} value={v.id} sx={{ fontSize: '11px' }}>
                                  {v.title} - ₹{v.price}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}

                        <Checkbox
                          checked={isSelected}
                          sx={{
                            '&.Mui-checked': {
                              color: '#DA6E0B',
                            },
                          }}
                          onClick={() => handleSelectMultipleProducts(product, selectedVariant)}
                        />

                      </div>
                    );
                  })}
                </div>

                {isLoading &&
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <CircularProgress style={{
                      color: "#DA6E0B"
                    }} />
                  </div>
                }
              </div>

            </div>
          </DialogContent>

        </Dialog>

        <Dialog
          open={open2} scroll={'paper'} onClose={handleCloseDialog2}
          // ref={HerbalmedicinesElementRef}
          fullWidth={true}
          maxWidth={'lg'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle>
            <div className="flex justify-between flex-row w-auto">
              <IconButton onClick={handleCloseDialog2}>
                <ArrowBackIcon />
              </IconButton>
              <Button style={{
                textTransform: "none",
                borderRadius: "0",
                backgroundColor: "#DA6E0B",
                color: "white",
                border: "none",
                boxSizing: "border-box",
                borderRadius: "5px",
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 500,
                padding: "10px",
              }} onClick={handleCloseDialog2}>
                Save and Close
              </Button>
            </div>
          </DialogTitle>

          <DialogContent>
            <div className="Herbal-products-container px-4 py-2 h-100">

              <div className="flex flex-row justify-between items-center mb-3">
                <p className="Prescription-sh-h">Food to be included</p>
              </div>

              <Autocomplete
                sx={{ margin: "10px" }}
                options={Object?.values(AllDiet)
                  .flat()
                  .filter((e) => !Foodtobeavoided.some((i) => i.id === e.id))}
                getOptionLabel={(option) => option.englishName}
                onInputChange={handleSearchChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search diets"
                    variant="outlined"
                    fullWidth
                  />
                )}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option.id}
                    onClick={() => {
                      setSearchTerm("");
                      handleCheckboxChange(
                        option,
                        FoodtobeTaken.find((i) => i?.id === option?.id)
                          ? false
                          : true,
                        "included"
                      );
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={FoodtobeTaken.find(
                            (i) => i?.id === option?.id
                          )}
                        />
                      }
                      label={option.englishName}
                    />
                  </li>
                )}
              />

              <div>

                <div className="category-chips items-strech">
                  {Object.keys(AllDiet).map((category, index) => (
                    <div key={index}>
                      <button
                        className={`chip ${selectedCategory === category ? "active" : ""}`}
                        onClick={() =>
                          setSelectedCategory(selectedCategory === category ? "" : category)
                        }
                      >
                        {category}
                      </button>
                    </div>
                  ))}
                </div>

                {!selectedCategory && (
                  <div className="category">
                    <h3>{selectedCategory}</h3>
                    <div className="item-grid">
                      {Object?.values(AllDiet)
                        .flat()
                        ?.filter(
                          (e) => !Foodtobeavoided.some((i) => i.id === e.id)
                        )
                        .map((item) => {
                          const isChecked = FoodtobeTaken.some(
                            (i) => i.id === item.id
                          );

                          return (
                            <div
                              key={item.id}
                              className="food-item"
                              onClick={() =>
                                handleCheckboxChange(item, !isChecked, "included")
                              }
                            >
                              <div className="food-item-img-container mb-2">
                                <img
                                  src={item?.imageLink}
                                  alt={item?.englishName}
                                  className="food-image"
                                />
                                <input
                                  type="checkbox"
                                  className="overlay-checkbox"
                                  checked={isChecked}
                                  readOnly
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    top: "5px",
                                    right: "8px",
                                  }}
                                />
                              </div>
                              <p className="mt-5">{item?.englishName}</p>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}

                {(selectedCategory && AllDiet[selectedCategory]
                  ? [selectedCategory]
                  : Object.keys(AllDiet)
                ).map((category) => (
                  <div className="category" key={category}>
                    <h3>{category}</h3>
                    <div className="item-grid">
                      {AllDiet[category]
                        ?.filter((e) => !Foodtobeavoided.some((i) => i.id === e.id))
                        .map((item) => {
                          const isChecked = FoodtobeTaken.some((i) => i.id === item.id);

                          return (
                            <div
                              key={item.id}
                              className="food-item"
                              onClick={() =>
                                handleCheckboxChange(item, !isChecked, "included")
                              }
                            >
                              <div className="food-item-img-container mb-2">
                                <img
                                  src={item?.imageLink}
                                  alt={item?.englishName}
                                  className="food-image"
                                />
                                <input
                                  type="checkbox"
                                  className="overlay-checkbox"
                                  checked={isChecked}
                                  readOnly
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    top: "5px",
                                    right: "8px",
                                  }}
                                />
                              </div>
                              <p className="mt-5">{item?.englishName}</p>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                ))}


              </div>
            </div>
          </DialogContent>





        </Dialog>

        <Dialog
          open={open3} scroll={'paper'} onClose={handleCloseDialog3}
          // ref={HerbalmedicinesElementRef}
          fullWidth={true}
          maxWidth={'lg'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"

        >

          <DialogTitle>
            <div className="flex justify-between flex-row w-auto">
              <IconButton onClick={handleCloseDialog3}>
                <ArrowBackIcon />
              </IconButton>
              <IconButton onClick={handleCloseDialog3}>
                <Button style={{
                  textTransform: "none",
                  borderRadius: "0",
                  backgroundColor: "#DA6E0B",
                  color: "white",
                  border: "none",
                  boxSizing: "border-box",
                  borderRadius: "5px",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                  padding: "10px",
                }}>
                  Save and Close
                </Button>
              </IconButton>
            </div>
          </DialogTitle>

          <DialogContent dividers tabIndex={-1}>
            <div className="Herbal-products-container px-4 py-2 w-auto h-full overflow-y-auto">

              <div className="flex flex-row justify-between items-center mb-3">
                <p className="Prescription-sh-h">Food to be Minimal</p>
              </div>

              <Autocomplete
                sx={{ margin: "10px" }}
                options={Object?.values(AllDiet)
                  .flat()
                  .filter((e) => !FoodtobeTaken.some((i) => i.id === e.id))}
                getOptionLabel={(option) => option.englishName}
                onInputChange={handleSearchChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search diets"
                    variant="outlined"
                    fullWidth
                  />
                )}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option.id}
                    onClick={() => {
                      setSearchTerm("");
                      handleCheckboxChange(
                        option,
                        Foodtobeavoided.find((i) => i?.id === option?.id)
                          ? false
                          : true,
                        "avoided"
                      );
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={Foodtobeavoided.find(
                            (i) => i?.id === option?.id
                          )}
                        />
                      }
                      label={option.englishName}
                    />
                  </li>
                )}
              />

              <div>
                <div className="category-chips">
                  {Object.keys(AllDiet).map((category, index) => (
                    <button
                      key={index}
                      className={`chip ${selectedCategory === category ? "active" : ""}`}
                      onClick={() =>
                        setSelectedCategory(selectedCategory === category ? "" : category)
                      }
                    >
                      {category}
                    </button>
                  ))}


                </div>

                {!selectedCategory && (
                  <div className="category">
                    <h3>{selectedCategory}</h3>
                    <div className="item-grid">
                      {Object?.values(AllDiet)
                        .flat()
                        ?.filter((e) => !FoodtobeTaken.some((i) => i.id === e.id))
                        .map((item) => {
                          const isChecked = Foodtobeavoided.some(
                            (i) => i.id === item.id
                          );

                          return (
                            <div
                              key={item.id}
                              className="food-item"
                              onClick={() =>
                                handleCheckboxChange(item, !isChecked, "avoided")
                              }
                            >
                              <div className="food-item-img-container mb-2">
                                <img
                                  src={item?.imageLink}
                                  alt={item?.englishName}
                                  className="food-image"
                                />
                                <input
                                  type="checkbox"
                                  className="overlay-checkbox"
                                  checked={isChecked}
                                  readOnly
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    top: "5px",
                                    right: "8px",
                                  }}
                                />
                              </div>
                              <p className="mt-5">{item?.englishName}</p>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
                {(selectedCategory && AllDiet[selectedCategory]
                  ? [selectedCategory]
                  : Object.keys(AllDiet)
                ).map((category) => (
                  <div className="category" key={category}>
                    <h3>{category}</h3>
                    <div className="item-grid">
                      {AllDiet[category]
                        ?.filter((e) => !FoodtobeTaken.some((i) => i.id === e.id))
                        .map((item) => {
                          const isChecked = Foodtobeavoided.some((i) => i.id === item.id);

                          return (
                            <div
                              key={item.id}
                              className="food-item"
                              onClick={() =>
                                handleCheckboxChange(item, !isChecked, "avoided")
                              }
                            >
                              <div className="food-item-img-container mb-2">
                                <img
                                  src={item?.imageLink}
                                  alt={item?.englishName}
                                  className="food-image"
                                />
                                <input
                                  type="checkbox"
                                  className="overlay-checkbox"
                                  checked={isChecked}
                                  readOnly
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    top: "5px",
                                    right: "8px",
                                  }}
                                />
                              </div>
                              <p className="mt-5">{item?.englishName}</p>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                ))}

              </div>

            </div>
          </DialogContent>


        </Dialog>

        <Dialog open={open4} fullScreen onClose={handleCloseDialog4}>
          <div className="Herbal-products-container">
            <div className="flex justify-between flex-row w-auto">
              <IconButton onClick={handleCloseDialog4}>
                <ArrowBackIcon />
              </IconButton>
              <IconButton onClick={handleCloseDialog4}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className="flex flex-row justify-between items-center mb-3">
              <p className="Prescription-sh-h">Recipes</p>
            </div>
            <h2>Filter by Category</h2>
            <div className="category-chips mt-2">
              {allCategories.map((category) => (
                <button
                  key={category}
                  className={`chip ${selectedCategories.includes(category) ? "active" : ""
                    }`}
                  onClick={() => handleCategoryToggle(category)}
                >
                  {category}
                </button>
              ))}
            </div>

            <h2>Filter by Dosha</h2>

            <div className="category-chips mt-2">
              {doshaOptions.map(({ code, label }) => (
                <button
                  key={code}
                  className={`chip ${selectedDoshas.includes(code) ? "active" : ""}`}
                  onClick={() => handleDoshaToggle(code)}
                >
                  {label}
                </button>
              ))}
            </div>

            <TextField
              sx={{ margin: "10px" }}
              label="Search Recipes"
              variant="outlined"
              fullWidth
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <div className="flex flex-wrap justify-center items-stretch">
              {filteredRecipes
                .filter((recipe) =>
                  recipe.recipe.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .sort((a, b) => a.recipe.localeCompare(b.recipe)) // <-- Added sorting here
                .map((item) => (
                  <div
                    key={item.id}
                    className="food-item relative"
                    onClick={() =>
                      handleSelectRecipe(
                        item,
                        !selectedRecipes.some((i) => i.id === item.id)
                      )
                    }
                    onMouseEnter={() => setHoveredRecipe(item)}
                    onMouseLeave={() => setHoveredRecipe(null)}
                  >
                    <div className="food-item-img-container mb-2">
                      <img
                        src={item.imageLink}
                        alt={item.recipe}
                        className="food-image"
                      />
                      <input
                        type="checkbox"
                        className="overlay-checkbox"
                        checked={selectedRecipes.some((i) => i.id === item.id)}
                        readOnly
                        style={{
                          width: "auto",
                          height: "auto",
                          top: "5px",
                          right: "8px",
                        }}
                      />
                    </div>
                    <p
                      className="mt-5 w-full"
                      style={{ wordWrap: "break-word", width: "10rem" }}
                    >
                      {item.recipe}
                    </p>
                    {hoveredRecipe?.id === item.id && (
                      <div
                        className="absolute bg-gray-100 text-black text-sm p-1 rounded shadow-lg"
                        style={{ zIndex: 10 }}
                      >
                        <p>
                          <strong>Decreases Dosha:</strong> {item.decreasesDosha}
                        </p>
                        <p>
                          <strong>Info:</strong> {item.info}
                        </p>
                        <p>
                          <strong>Increases Dosha:</strong> {item.increasesDosha}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
            </div>

          </div>
        </Dialog>

        <Dialog open={openRecipeAI} fullScreen onClose={() => setOpenRecipeAI(false)}>
          <DialogContent>
            <div className="">
              <div className="flex justify-between flex-row w-auto">
                <IconButton onClick={() => setOpenRecipeAI(false)}>
                  <ArrowBackIcon />
                </IconButton>
                <IconButton onClick={() => setOpenRecipeAI(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
              <div className="flex flex-row justify-between items-center mb-3 m-5">
                <p className="Prescription-sh-h">Recipes AI Suggestions</p>
              </div>
              {recipeLoading ? <LoadingComponent loading={recipeLoading} /> :
                <>
                  <div className="p-5 flex flex-col gap-5" >
                    <p style={{
                      fontSize: "18px",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 500,
                    }}>Breakfast</p>
                    <div className="flex flex-wrap justify-center items-stretch">
                      {recipeAIRecommendation
                        .filter((recipe) => recipe.time?.includes('breakfast'))
                        .map((item) => (
                          <div
                            key={item.id}
                            className="food-item relative"
                            onClick={() =>
                              handleSelectRecipe(
                                item,
                                !selectedRecipes.some((i) => i.id === item.id)
                              )
                            }
                            onMouseEnter={() => setHoveredRecipe(item)}
                            onMouseLeave={() => setHoveredRecipe(null)}
                          >
                            <div className="food-item-img-container mb-2">
                              <img
                                src={item.imageLink}
                                alt={item.recipe}
                                className="food-image"
                              />
                              <input
                                type="checkbox"
                                className="overlay-checkbox"
                                checked={selectedRecipes.some((i) => i.id === item.id)}
                                readOnly
                                style={{
                                  width: "auto",
                                  height: "auto",
                                  top: "5px",
                                  right: "8px",
                                }}
                              />
                            </div>

                            <p
                              className="mt-5 w-full"
                              style={{ wordWrap: "break-word", width: "10rem" }}
                            >
                              {item?.recipe || item?.name}
                            </p>

                            {hoveredRecipe?.id === item.id && (
                              <div
                                className="absolute bg-gray-100 text-black text-sm p-1 rounded shadow-lg"
                                style={{ zIndex: 10 }}
                              >
                                <p>
                                  <strong>Reason:</strong> {item?.reason}
                                </p>

                              </div>
                            )}
                          </div>
                        ))}
                    </div>

                  </div>

                  <div className="p-5 flex flex-col gap-5" >
                    <p style={{
                      fontSize: "18px",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 500,
                    }}>Lunch</p>
                    <div className="flex flex-wrap justify-center items-stretch">
                      {recipeAIRecommendation
                        .filter((recipe) => recipe.time?.includes('lunch'))
                        .map((item) => (
                          <div
                            key={item.id}
                            className="food-item relative"
                            onClick={() =>
                              handleSelectRecipe(
                                item,
                                !selectedRecipes.some((i) => i.id === item.id)
                              )
                            }
                            onMouseEnter={() => setHoveredRecipe(item)}
                            onMouseLeave={() => setHoveredRecipe(null)}
                          >
                            <div className="food-item-img-container mb-2">
                              <img
                                src={item.imageLink}
                                alt={item.recipe}
                                className="food-image"
                              />
                              <input
                                type="checkbox"
                                className="overlay-checkbox"
                                checked={selectedRecipes.some((i) => i.id === item.id)}
                                readOnly
                                style={{
                                  width: "auto",
                                  height: "auto",
                                  top: "5px",
                                  right: "8px",
                                }}
                              />
                            </div>

                            <p
                              className="mt-5 w-full"
                              style={{ wordWrap: "break-word", width: "10rem" }}
                            >
                              {item?.recipe || item?.name}
                            </p>

                            {hoveredRecipe?.id === item.id && (
                              <div
                                className="absolute bg-gray-100 text-black text-sm p-1 rounded shadow-lg"
                                style={{ zIndex: 10 }}
                              >
                                <p>
                                  <strong>Reason:</strong> {item?.reason}
                                </p>

                              </div>
                            )}
                          </div>
                        ))}
                    </div>

                  </div>

                  <div className="p-5 flex flex-col gap-5" >
                    <p style={{
                      fontSize: "18px",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 500,
                    }}>Dinner</p>
                    <div className="flex flex-wrap justify-center items-stretch">
                      {recipeAIRecommendation
                        .filter((recipe) => recipe.time?.includes('dinner'))
                        .map((item) => (
                          <div
                            key={item.id}
                            className="food-item relative"
                            onClick={() =>
                              handleSelectRecipe(
                                item,
                                !selectedRecipes.some((i) => i.id === item.id)
                              )
                            }
                            onMouseEnter={() => setHoveredRecipe(item)}
                            onMouseLeave={() => setHoveredRecipe(null)}
                          >
                            <div className="food-item-img-container mb-2">
                              <img
                                src={item.imageLink}
                                alt={item.recipe}
                                className="food-image"
                              />
                              <input
                                type="checkbox"
                                className="overlay-checkbox"
                                checked={selectedRecipes.some((i) => i.id === item.id)}
                                readOnly
                                style={{
                                  width: "auto",
                                  height: "auto",
                                  top: "5px",
                                  right: "8px",
                                }}
                              />
                            </div>

                            <p
                              className="mt-5 w-full"
                              style={{ wordWrap: "break-word", width: "10rem" }}
                            >
                              {item?.recipe || item?.name}
                            </p>

                            {hoveredRecipe?.id === item.id && (
                              <div
                                className="absolute bg-gray-100 text-black text-sm p-1 rounded shadow-lg"
                                style={{ zIndex: 10 }}
                              >
                                <p>
                                  <strong>Reason:</strong> {item?.reason}
                                </p>

                              </div>
                            )}
                          </div>
                        ))}
                    </div>

                  </div>
                </>
              }
            </div>
          </DialogContent>

        </Dialog>

        <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
          <div className="p-4 w-[420px] flex flex-col gap-3">
            <p className="text-lg font-semibold">{activeType} – Add More</p>
            {activeType && renderItems(
              activeType.toLowerCase(),
              Practices?.[activeType.toLowerCase()] || [],
              {
                yoga: yogalist,
                pranayama: pranayama,
                meditation: meditationList
              }[activeType.toLowerCase()],
              activeType === "Meditation" ? "duration" : "reps"
            )}
          </div>
        </Drawer>

        <Dialog open={!!dialogParamKey} onClose={closeDialog} maxWidth="md" fullWidth>
          <DialogTitle style={{ fontSize: "18px", fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>{currentParam?.title ?? "Assessment"}</DialogTitle>
          <DialogContent dividers>
            <div className="space-y-6">
              {currentParam?.questions?.map((question, index) => (
                <div key={question.id} className="space-y-2 border-b border-[#D3D3D3] pb-2">
                  <p className="font-medium text-gray-700" style={{ fontSize: "16px", fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                    {index + 1}. {question.text}
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                    {question.options.map((option) => {
                      const inputName = `${currentParam.parameter}-${question.id}-dialog`; // different group name
                      const inputId = `${inputName}-${option.value}`;
                      return (
                        <label key={option.value} htmlFor={inputId}
                          className="flex items-start space-x-3 p-2 rounded hover:bg-gray-50 cursor-pointer">
                          <input
                            id={inputId}
                            type="radio"
                            name={inputName}
                            checked={question.answer === option.value}
                            onChange={() =>
                              handleAnswerSelect(currentParam.parameter, question.id, option.value)
                            }
                            className="mt-1 text-blue-600 focus:ring-blue-500"
                          />
                          <span className="text-gray-700" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>{option.text}</span>
                        </label>
                      );

                    })}

                  </div>
                </div>
              ))}

            </div>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            {
              currentParam?.value ? (

                <div className="px-3 py-2 bg-blue-50 rounded border border-blue-100" style={{ fontSize: "16px", fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                  <p className="text-sm text-blue-800">
                    Current assessment:{" "}
                    {isEditingResult === currentParam.parameter ? (

                      <div className="flex gap-2">
                        <select
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          className="border rounded px-2 py-1 text-sm"
                        >
                          <option value="">Select value</option>
                          {ayurvedaFields[currentParam.parameter]?.options?.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={() => handleSaveResult(currentParam.parameter)}
                          className="px-2 py-1 bg-blue-500 text-white rounded text-sm"
                        >
                          Save
                        </button>
                        <button
                          onClick={() => setIsEditingResult(null)}
                          className="px-2 py-1 bg-gray-200 rounded text-sm"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2" >
                        <span
                          className={`px-3 py-1 rounded text-sm font-medium cursor-pointer ${currentParam.value
                            ? 'bg-green-100 text-green-800'
                            : 'bg-gray-100 text-gray-500'
                            }`}
                          onClick={() => setDialogParamKey(currentParam.parameter)}
                        >
                          {currentParam.value || 'Asses Now'}

                        </span>
                        <button
                          onClick={() => handleEditResult(currentParam)}
                          className="text-blue-500 hover:text-blue-700 text-sm"
                        >
                          Edit
                        </button>
                      </div>
                    )}
                  </p>
                </div>
              ) : (
                <div />
              )}


            <Button onClick={closeDialog} variant="outlined">
              Close
            </Button>
          </DialogActions>

        </Dialog>

      </div >
    </div >
  );

}

export default UploadPrescription;